
import { coerceNumberProperty } from "@angular/cdk/coercion";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { ActiontrackerConstantsService } from "../../../actiontracker/services/actiontracker-constants.service";
import { UnitTreeNode } from "../../../masterscreen/model/unit-tree.model";
import { MasterscreenService } from "../../../masterscreen/services/masterscreen.service";
import { ActionListForHSEAdvisor } from "../../../observation/components/raise-observation/raise-observation.component";
import { User } from "../../../shared/models/user.model";
import { ObservationService } from "../../../observation/services/observation.service";
import { SpecificationData } from "../../../shared/components/category/category.component";
import { UserLogInActivity, UserPermissionParameters } from "../../../shared/models/user.model";
import { BaseService } from "../../../shared/services/base.service";
import { ConstantsService } from "../../../shared/services/constants.service";
import { NotificationsService } from "../../../shared/services/notification.service";
import { FileUtility } from "../../../shared/utility/file.utility";
import { RiskPermission } from "../../model/riskpermission.model";
import { RiskRequest,RiskRequestHEMP,RiskRequestPreventiveActions,RiskRequestMitigativePlan,ToolDetails } from "../../model/riskRequest.model";
import { AssignActionPost } from "./../../../actiontracker/model/actionDetails.model";
import { SearchText } from "./../../../observation/model/searchTexts.model";
import { CommonService } from "./../../../shared/services/common.service";
import { RaiseRiskAllMaster } from "./../../model/raiseRiskAllMaster";
import { AssetsRisk, EnvironmentRisk, NPTRisk, PearDetails, PeopleRisk, RaiseRisk, RaiseRiskShowErrorMessages, ReputationRisk } from "./../../model/riskRequest.model";
import { RiskConstantsService } from "./../../services/risk-constants.service";
import { RiskService } from "./../../services/risk.service";
import { HseErrorHandlerService } from "../../../shared/services/hse-error-handler.service";
import { Login } from "../../model/login.model";
import { RiskControlTechnique } from "../../model/RiskControlTechniques.model";

import { SelectItem } from "primeng/api";

import * as XLSX from 'xlsx';
type AOA = string[][];
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'ara-raise-risk-hemp',
  templateUrl: './raise-risk-hemp.component.html',
  styleUrls: ['./raise-risk-hemp.component.css']
})
export class RaiseRiskHEMPComponent implements OnInit {

  selectedUserEmp: User;
  selectedUserForRiskOwner: User;
  isRiskReportErrorMsg: boolean = false;
  isRiskOwnerPartyErrorMsg: boolean = false;
  selectedLocation: number = 0;
  isLocationErrorMsg: boolean = false;
  locations: SelectItem[];
  login: Login;
  searchedUser : User;
  loggedInUser = this.baseService.getItemFromSession("loggedInUser");
  loggedInUserJSON = JSON.parse(this.loggedInUser);
  raiseRisk = new RaiseRisk();
  raiseRiskAllMaster = new RaiseRiskAllMaster();
  riskRequest = new RiskRequest();
  updateriskData = new RiskRequest();
  PotentialPeopleRisk = new PeopleRisk();
  PotentialAssetsRisk = new AssetsRisk();
  PotentialEnvironmentRisk = new EnvironmentRisk();
  PotentialReputationRisk = new ReputationRisk();
  PotentialNPTRisk = new NPTRisk();
  PotentialRAMClassificationList: Array<any> = [];

  ResidualPeopleRisk = new PeopleRisk();
  ResidualAssetsRisk = new AssetsRisk();
  ResidualEnvironmentRisk = new EnvironmentRisk();
  ResidualReputationRisk = new ReputationRisk();
  ResidualNPTRisk = new NPTRisk();
  ResidualRAMClassificationList: Array<any> = [];

  RiskassessmentPeople = new PeopleRisk();
  RiskassessmentAssets = new AssetsRisk();
  RiskassessmentEnvironment = new EnvironmentRisk();
  RiskassessmentReputation = new ReputationRisk();
  RiskassessmentNPT = new NPTRisk();
  RiskassessmentClassificationList: Array<any> = [];
  pearMaster: any = [];
  riskMovement: any = [];
  consequenceMaster: any = [];
  severityMaster: any = [];
  potentialRiskColor = "";
  residualRiskColor = "";
  actionList: any = [];
  actionPost: AssignActionPost | undefined;
  PreventiveActions: RiskRequestPreventiveActions ;
  PreventiveActionsList:any=[];
  MitigativePlans: RiskRequestMitigativePlan ;
  MitigativePlansList:any=[];
  searchTexts: SearchText = new SearchText();
  userResults: User[] = [];
  displayErrorMessage: any;
  successDetails: string = "";
  errorDetails: any;
  alertType: string = "";
  confirmMessage: string = "";
  isUserHasHSEMemberRole: boolean = false;
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[] | undefined;
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[] | undefined;
  selectedRiskRequestId: number = 0;
  UpdatedPotentialPear: PearDetails[] | undefined;
  UpdatedResidualPear: PearDetails[] | undefined;
  UpdatedAssessmentPear: PearDetails[] | undefined;
  data: CustomObject[] = [];

  ShowPeopleSeverityMessage: boolean = false;
  ShowPeopleLikelihooodMessage: boolean = false;
  ShowEnvironmentSeverityMessage: boolean = false;
  ShowEnvironmentlihooodMessage: boolean = false;
  ShowAssetsSeverityMessage: boolean = false;
  ShowAssetslihooodMessage: boolean = false;
  ShowReputationSeverityMessage: boolean = false;
  ShowReputationlihooodMessage: boolean = false;
  ShowNPTSeverityMessage: boolean = false;
  ShowNPTlihooodMessage: boolean = false;
  isInactiveLocation: boolean = false;

  residualPeopleSeverityMessage: boolean = false;
  residualPeopleLikelihooodMessage: boolean = false;
  residualEnvironmentSeverityMessage: boolean = false;
  residualEnvironmentlihooodMessage: boolean = false;
  residualAssetsSeverityMessage: boolean = false;
  residualAssetslihooodMessage: boolean = false;
  residualReputationSeverityMessage: boolean = false;
  residualReputationlihooodMessage: boolean = false;
  residualNPTSeverityMessage: boolean = false;
  residualNPTlihooodMessage: boolean = false;

  assessmentPeopleSeverityMessage: boolean = false;
  assessmentPeopleLikelihooodMessage: boolean = false;
  assessmentEnvironmentSeverityMessage: boolean = false;
  assessmentEnvironmentlihooodMessage: boolean = false;
  assessmentAssetsSeverityMessage: boolean = false;
  assessmentAssetslihooodMessage: boolean = false;
  assessmentReputationSeverityMessage: boolean = false;
  assessmentReputationlihooodMessage: boolean = false;
  assessmentNPTSeverityMessage: boolean = false;
  assessmentNPTlihooodMessage: boolean = false;
  ShowriskMovementmessage: boolean = false;
  GraphDisplay: boolean = false;
  max: number = 0;
  pear: string = "";
  retVal: boolean | undefined;
  userActivityList: UserLogInActivity[] = [];
  deletionReason: any;
  isDeletionreason: boolean | undefined;
  isActionOpen: boolean = false;
  actionDetailsForHseAdvisor: ActionListForHSEAdvisor;
  cancelRecord: boolean | undefined;
  deleteRecord: boolean | undefined;
  deleteActionId: number | undefined;
  actionStatusId: number = 25;
  cancelActionId: any;
  cancellationReason: any;
  cancelStatusId: number = 26;
  showCancellationmsg: boolean = false;
  validatePopUp: boolean = false;
  showDeletionmsg: boolean = false;
  disableRisk: boolean = false;
  riskPermission: RiskPermission;
  userPermissions: UserPermissionParameters;
  unitList: any[] = [];
  selectedUnit: any;
  isNew: boolean = false;
  updateriskDataForDetails: any = [];
  riskLoaded: boolean | undefined;
  tempUnits: string | undefined;
  environmentMaster: any = [];
  assetsMaster: any = [];
  reputationMaster: any = [];
  NPTMaster: any = [];
  riskIds: any[] = [];
  riskIndex: number = -1;
  isNext: boolean = true;
  isPrevious: boolean = true;
  alertFrom: string = "";
  moduleList: any[] = [];
  moduleId: number = 0;
  specificationDetailsData: SpecificationData;
  lifeSavingCheckedValueData: any[] = [];
  sourceId: number = 0;
  ToolDetails : ToolDetails;
  unitTree: UnitTreeNode[] = [];
  accept: string;
  tempFiles: any[] = [];
  multiple: boolean = true;
  independentPermissions: any;
  isActive: boolean = false;
  lifeSavingCheckedValue: any[];
  specificationResponseData: SpecificationData;
  public isShowCategory: boolean = false;
	isShowSpecification: boolean = false;
  specificationData: SpecificationData[];
    //BOC Pritesh
    dialogHeight: string;
    dialogWidth: string;
    ReportUserId : number;
    ReportModule : string;
    ReportRecordId : number;
    ReportProcessId : number = 0;
    ReportclosePopup: boolean = false;
    ResidualP:string = '';
    ResidualE:string = '';
    ResidualA:string = '';
    ResidualR:string = '';
    ResidualN:string = '';
    CurrentP:string = '';
    CurrentE:string = '';
    CurrentA:string = '';
    CurrentR:string = '';
    CurrentN:string = '';
    //EOC Pritesh
    unitError : boolean;
    editEnabled: boolean = true;
    IsNewRecord:boolean = true;

    contracts: { label: string; value: string }[] = [];
    unitContractDetails: any[] = [];
    isHasContractDetails: boolean = true;
    isContractErrorMsg: boolean = true;
    isEmployeeUnit:boolean=true;
    isContractHolder: boolean = false;
    selectedContractId: number;
    riskMovementText:string = "";
    riskControlTechnique: RiskControlTechnique[] = [];
    riskControlTechniqueDet:any;
    selectedriskControlTechniqueId: string[] = [];
    riskControlTechniqueErrorMsg: boolean = false;

    updateActionTrack: any[];
    selctedRiskId:any[];
    RiskControlIdDet:any;
    RiskId:number = 0;
    ApproverPopup : boolean = false;

  constructor(
    private ref: ChangeDetectorRef,
    private riskService: RiskService,
    private baseService: BaseService,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private observationService: ObservationService,
    private masterscreenService: MasterscreenService,
    private notificationsService: NotificationsService,
    private hseErrorHandler: HseErrorHandlerService,
    private translate: TranslateService,
    private http: HttpClient
  ) {
    this.data = [];
    this.riskRequest = new RiskRequest();
    this.riskRequest.RiskRequestHEMP = new RiskRequestHEMP();
    this.actionDetailsForHseAdvisor = new ActionListForHSEAdvisor();
    this.riskPermission = new RiskPermission();
    this.userPermissions = new UserPermissionParameters();
    this.specificationDetailsData = new SpecificationData();
    this.accept =
      ".jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.pdf,.PDF,.docx,.DOCX,.xlsx,.XLSX,.doc,.DOC,.pptx,.PPTX,.ppt,.PPT,.heic,.HEIC,.heif,.HEIF,.xls,.XLS";
  }
	
  ngOnInit() {
    this.baseService.showRootLoader = true;
    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");  
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    const apiRequestUnit = {
      Model: {
        ModuleId: ConstantsService.PermissionMatrixModules.Risk,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : this.IsNewRecord
      }
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this)
    );
    
    this.login = new Login();
    this.selectedUserEmp = new User();
    this.selectedUserForRiskOwner = new User();
    this.login.CompanyId = this.loggedInUserJSON.Company.CompanyId;
    this.login.ID = this.loggedInUserJSON.UserId;
    // Set routeURL and route name for Risk
    this.routesFlag = RiskConstantsService.RiskNavigation.InnerRoutes;
    this.reportRoutes = RiskConstantsService.RiskNavigation.ReportRoutes;
    this.route.params.subscribe(params => {
      this.selectedRiskRequestId = coerceNumberProperty(params["riskId"]);
      this.Approval = isNaN(params["App"])? 0 :coerceNumberProperty(params["App"]);
      this.sourceId = this.selectedRiskRequestId;
    });
    this.pearMaster = RiskConstantsService.Pear;
    this.riskMovement = RiskConstantsService.RiskMovement;
    this.consequenceMaster = RiskConstantsService.Consequence;
    this.severityMaster = RiskConstantsService.PeopleSeverity;
    this.environmentMaster = RiskConstantsService.EnvironmentSeverity;
    this.assetsMaster = RiskConstantsService.AssetsSeverity;
    this.reputationMaster = RiskConstantsService.ReputationSeverity;
    this.NPTMaster = RiskConstantsService.NPTSeverity;
    this.displayErrorMessage = new RaiseRiskShowErrorMessages();
    this.moduleId = ConstantsService.PermissionMatrixModules.Risk;
    this.actionList = [];
    this.addAction();
    this.addPreventiveAction();
    this.addMitigativePlan();
    this.getRiskControlTechniques();
    this.baseService.translatorListener.subscribe(data => {
      this.translate.use(data);
    });
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    this.disableRisk = false;
    if (this.sourceId !== 0 && this.sourceId) {
      
      this.IsNewRecord = false;
      
    }
  }
  callbackMethodForUnitDetails(response: { Success: any; Result: any[]; }) {
    if (response.Success) {
      this.unitList = response.Result;
      const apiRequest = {
        Model: {
          GetActiveNodes: this.IsNewRecord,
          UserId: this.loggedInUserJSON.UserId
        }
      };
      this.masterscreenService.getTreeData(
        apiRequest,
        this.callbackMethodForGetTreeData.bind(this)
      );
    }
  }
  getTexts(color, Pear) {
    if (Pear === "People") {
      if (color === "riskColorRed") {
        return "High";
      } else if (color === "riskColorYellow") {
        return "Medium";
      } else if (color === "riskColorBlue") {
        return "Low";
      }
    } else if ("Environment") {
      if (color === "riskColorRed") {
        return "High";
      } else if (color === "riskColorYellow") {
        return "Medium";
      } else if (color === "riskColorBlue") {
        return "Low";
      }
    } else if ("Assets") {
      if (color === "riskColorRed") {
        return "High";
      } else if (color === "riskColorYellow") {
        return "Medium";
      } else if (color === "riskColorBlue") {
        return "Low";
      }
    } else if ("Reputation") {
      if (color === "riskColorRed") {
        return "High";
      } else if (color === "riskColorYellow") {
        return "Medium";
      } else if (color === "riskColorBlue") {
        return "Low";
      }
    }
  }
  getTextClass(colorClass) {
    switch (colorClass) {
      case "riskColorBlue":
        return "text-white";
      case "riskColorYellow":
        return "text-black";
      case "riskColorRed":
        return "text-white";
    }
  }
  getPermissionDetails(unitId: number) {
    this.baseService.showRootLoader = true;
    this.userPermissions.ModuleId =
      ConstantsService.PermissionMatrixModules.Risk;
    this.userPermissions.UserId = this.loggedInUserJSON.UserId;
    this.userPermissions.UnitId = unitId;
    const apiRequest = {
      Model: this.userPermissions
    };
    this.commonService.getPermissionDetailsForUser(
      apiRequest,
      this.callbackMethodForgetPermissionDetails.bind(this)
    );
  }

  callbackMethodForgetPermissionDetails(response: { Result: any; }) {
    const permissions = response.Result;
    if (response.Result) {
      this.riskPermission = permissions.RiskPermission;
      if (!this.riskPermission.RSK_Add && !this.riskPermission.RSK_Add_Unit && !this.riskPermission.RSK_Admin && !this.riskPermission.RSK_Admin_Unit) {
        this.routesFlag.find(s => s.routeName == RiskConstantsService.RiskRequest.RaiseRisk).isClickable = false;
      }
      if (
        !this.riskPermission.RSK_Admin &&
        !this.riskPermission.RSK_Admin_Unit &&
        !this.riskPermission.RSK_Own
      ) {
        this.disableRisk = true;
      }
      if (
        this.selectedRiskRequestId === 0 &&
        (this.riskPermission.RSK_Add || this.riskPermission.RSK_Add_Unit)
      ) {
        this.disableRisk = false;
      }
      if (
        this.selectedRiskRequestId > 0 &&
        (this.riskRequest.Status === "Cancelled" ||
          this.riskRequest.Status === "Deleted")
      ) {
        this.disableRisk = true;
      }
      // if (
      //   this.selectedRiskRequestId > 0 && this.riskRequest.RaisedBy === this.loggedInUserJSON.UserId &&
      //   (this.riskRequest.Status === "Draft" ||
      //     this.riskRequest.Status === "New")
      // ) {
      //   this.disableRisk = false;
      // }

    }
    this.baseService.showRootLoader = false;
  }
  getRiskRequestForEdit() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        RiskRequestId: this.selectedRiskRequestId,
        Tool : ConstantsService.RiskManagementToolName.HEMP
      }
    };
    this.riskService.getRiskRequestForEditByTool(
      apiRequest,
      this.successGetRiskRequestForEdit.bind(this)
    );
  }
  isShowErrorDialog:boolean=false;
  Approval : number = 0;
  ShowButton:boolean=true;
  ShowApproveButton:boolean=false;
  ImportErrorList : any;
  RSKOwner: boolean =false;
  successGetRiskRequestForEdit(response: { Result: { RiskRequest: RiskRequest; ActionDetails: string | any[]; }; }) {
    this.closePopUp();
    if (response.Result && response.Result.RiskRequest) 
    {
      this.isShowErrorDialog=false;    
      if(this.isImport && response.Result.RiskRequest.ErrorList.length>0)
      {
    
        this.isShowErrorDialog=true;
        this.ImportErrorList = response.Result.RiskRequest.ErrorList;
      }
      this.actionList = response.Result.ActionDetails;
      //BOC Pritesh
      this.riskService.setoldActionData(
        JSON.stringify(this.actionList)
        );

      this.riskRequest = response.Result.RiskRequest;
      if(this.riskRequest.RiskManagementToolId==ConstantsService.RiskManagementTool.HEMP)
      {
      this.isActive =  this.riskRequest.Status == "New" ? true : false;
      this.ShowButton=false;
      if(this.Approval===0)
      {
      ////Code To check Approval is in progress
      
      if(  this.riskRequest.ApprovalStatus === 1 && this.riskRequest.ApprovalLevel>0 )
      {
        this.ShowButton=false;
        
        if(this.riskRequest.ApprovalLevel<this.riskRequest.ApprovalMaxLevel)
        {
        this.notificationsService.toastNotify(
         "error",
         "Warning Message",
         "Record Approval Process in Progress, You Cant Modify Record."
       );
        }
        else 
        {
          this.notificationsService.toastNotify(
            "error",
            "Warning Message",
            "Record Already Approved, You Cant Modify Record."
          );

        }   
      }
      else 
      {
        this.ShowButton=true;

      }
      }
      else 
      {
      this.ShowApproveButton = true;
      if(  this.riskRequest.ApprovalStatus == 2)
    {
        this.ShowApproveButton = false;
         this.notificationsService.toastNotify(
          "error",
          "Warning Message",
          "Record Rejected... Kindly wait for Resubmission of Data."
        );   
        
      
    }
     else 
      {
      if(   this.riskRequest.ApprovalLevel == this.riskRequest.ApprovalMaxLevel)
      {
         this.ShowApproveButton = false;
         this.notificationsService.toastNotify(
          "error",
          "Warning Message",
          "Record Already Approved..."
        );   
        
      }
      else if(  this.riskRequest.ApprovalLevel == this.Approval)
      {
         this.ShowApproveButton = false;
         this.notificationsService.toastNotify(
          "error",
          "Warning Message",
          "Record Already Approved..."
        );   
        
      }
      else if(  this.riskRequest.ApprovalMaxLevel < this.Approval)
      {
         this.ShowApproveButton = false;
         this.notificationsService.toastNotify(
          "error",
          "Warning Message",
          "Invalid For Approve..."
        );   
        
      }
      else if(  this.riskRequest.ApprovalLevel+1 != this.Approval)
      {
         this.ShowApproveButton = false;
         this.notificationsService.toastNotify(
          "error",
          "Warning Message",
          "Invalid Level For Approve..."
        );   
        
      }
      else 
      {

        this.CheckValidForApprove();
      }
    }
    
    }
      this.riskPermission.RSK_Own =
        this.riskRequest.RaisedBy === this.loggedInUserJSON.UserId
          ? true
          : false;
         this.RSKOwner=
         this.riskRequest.RaisedBy === this.loggedInUserJSON.UserId
           ? true
           : false;
      this.unitTree.forEach(element => {
        this.compareTreeNode(element, this.riskRequest.UnitId);
      });
      this.isEmployeeUnit=true;
      if(this.selectedUnit != undefined && this.selectedUnit.UnitTypeId == 2)
      {
        this.isEmployeeUnit=false;
        this.getContractDetails(this.selectedUnit.UnitId);
      }
      this.selectedContractId=this.riskRequest.ContractId;
      this.getPermissionDetails(this.riskRequest.UnitId);
      this.getIsActiveUnit(this.riskRequest.UnitId);
      this.riskLoaded = true;
      this.getLocation();
      this.selectedLocation = this.riskRequest.LocationId;
      this.selectedUserEmp = this.riskRequest.RiskIdentifiedByEmployee ? this.riskRequest.RiskIdentifiedByEmployee : new User();
      this.selectedUserForRiskOwner = this.riskRequest.RiskRequestHEMP.RiskOwnerParty ? this.riskRequest.RiskRequestHEMP.RiskOwnerParty : new User();
      this.selectedriskControlTechniqueId = this.riskRequest.RiskRequestHEMP.riskControlTechniqueIds;
      if (this.riskRequest.RiskRequestHEMP.RiskRequestPreventiveActions.length > 0) {
        this.PreventiveActionsList = this.riskRequest.RiskRequestHEMP.RiskRequestPreventiveActions;
      }
      if (this.riskRequest.RiskRequestHEMP.RiskRequestMitigativePlan.length > 0) {
        this.MitigativePlansList = this.riskRequest.RiskRequestHEMP.RiskRequestMitigativePlan;
      }
      this.riskControlTechnique.forEach(element => {
        this.selectedriskControlTechniqueId.forEach(Id => {
          if(element.Id.toString() == Id)
          {
            element.Checked = true;
          }
          else{
            if(element.Checked != true)
            {
            element.Checked = false;
            }
          }
        });
      });
      response.Result.RiskRequest.PotentialPEARList.forEach((potential: { RiskPear: string | String; RiskLikelihood: String; RiskSeverity: number; }) => {
        if (potential.RiskPear === "People") {
          const tempPear = new PeopleRisk();
          tempPear.PeopleRiskPear = potential.RiskPear;
          tempPear.PeopleRiskLikelihood = potential.RiskLikelihood;
          tempPear.PeopleRiskSeverity = potential.RiskSeverity;
          this.PotentialPeopleRisk = tempPear;
          this.PotentialPeopleRisk.PeopleRiskColor = this.riskService.getRiskColorClass(
            tempPear.PeopleRiskSeverity,
            tempPear.PeopleRiskLikelihood
          );
          this.PotentialPeopleRisk.PeopleSelected = true;
        }
        if (potential.RiskPear === "Assets") {
          const tempPear = new AssetsRisk();
          tempPear.AssetsRiskPear = potential.RiskPear;
          tempPear.AssetsRiskLikelihood = potential.RiskLikelihood;
          tempPear.AssetsRiskSeverity = potential.RiskSeverity;
          this.PotentialAssetsRisk = tempPear;
          this.PotentialAssetsRisk.AssetsRiskColor = this.riskService.getRiskColorClass(
            tempPear.AssetsRiskSeverity,
            tempPear.AssetsRiskLikelihood
          );
          this.PotentialAssetsRisk.AssetsSelected = true;
        }
        if (potential.RiskPear === "Environment") {
          const tempPear = new EnvironmentRisk();
          tempPear.EnvironmentRiskPear = potential.RiskPear;
          tempPear.EnvironmentRiskLikelihood = potential.RiskLikelihood;
          tempPear.EnvironmentRiskSeverity = potential.RiskSeverity;
          this.PotentialEnvironmentRisk = tempPear;
          this.PotentialEnvironmentRisk.EnvironmentRiskColor = this.riskService.getRiskColorClass(
            tempPear.EnvironmentRiskSeverity,
            tempPear.EnvironmentRiskLikelihood
          );
          this.PotentialEnvironmentRisk.EnvironmentSelected = true;
        }
        if (potential.RiskPear === "Reputation") {
          const tempPear = new ReputationRisk();
          tempPear.ReputationRiskPear = potential.RiskPear;
          tempPear.ReputationRiskLikelihood = potential.RiskLikelihood;
          tempPear.ReputationRiskSeverity = potential.RiskSeverity;
          this.PotentialReputationRisk = tempPear;
          this.PotentialReputationRisk.ReputationRiskColor = this.riskService.getRiskColorClass(
            tempPear.ReputationRiskSeverity,
            tempPear.ReputationRiskLikelihood
          );
          this.PotentialReputationRisk.ReputationSelected = true;
        }
        if (potential.RiskPear === "NPT") {
          const tempPear = new NPTRisk();
          tempPear.NPTRiskPear = potential.RiskPear;
          tempPear.NPTRiskLikelihood = potential.RiskLikelihood;
          tempPear.NPTRiskSeverity = potential.RiskSeverity;
          this.PotentialNPTRisk = tempPear;
          this.PotentialNPTRisk.NPTRiskColor = this.riskService.getRiskColorClass(
            tempPear.NPTRiskSeverity,
            tempPear.NPTRiskLikelihood
          );
          this.PotentialNPTRisk.NPTSelected = true;
        }
      });

      //Residual Pear
      response.Result.RiskRequest.ResidualPEARList.forEach((residual: { RiskPear: string | String; RiskLikelihood: String; RiskSeverity: number; }) => {
        if (residual.RiskPear === "People") {
          const tempPear = new PeopleRisk();
          tempPear.PeopleRiskPear = residual.RiskPear;
          tempPear.PeopleRiskLikelihood = residual.RiskLikelihood;
          tempPear.PeopleRiskSeverity = residual.RiskSeverity;
          this.ResidualPeopleRisk = tempPear;
          this.ResidualPeopleRisk.PeopleRiskColor = this.riskService.getRiskColorClass(
            tempPear.PeopleRiskSeverity,
            tempPear.PeopleRiskLikelihood
          );
          this.ResidualPeopleRisk.PeopleSelected = true;
        }
        if (residual.RiskPear === "Assets") {
          const tempPear = new AssetsRisk();
          tempPear.AssetsRiskPear = residual.RiskPear;
          tempPear.AssetsRiskLikelihood = residual.RiskLikelihood;
          tempPear.AssetsRiskSeverity = residual.RiskSeverity;
          this.ResidualAssetsRisk = tempPear;
          this.ResidualAssetsRisk.AssetsRiskColor = this.riskService.getRiskColorClass(
            tempPear.AssetsRiskSeverity,
            tempPear.AssetsRiskLikelihood
          );
          this.ResidualAssetsRisk.AssetsSelected = true;
        }
        if (residual.RiskPear === "Environment") {
          const tempPear = new EnvironmentRisk();
          tempPear.EnvironmentRiskPear = residual.RiskPear;
          tempPear.EnvironmentRiskLikelihood = residual.RiskLikelihood;
          tempPear.EnvironmentRiskSeverity = residual.RiskSeverity;
          this.ResidualEnvironmentRisk = tempPear;
          this.ResidualEnvironmentRisk.EnvironmentRiskColor = this.riskService.getRiskColorClass(
            tempPear.EnvironmentRiskSeverity,
            tempPear.EnvironmentRiskLikelihood
          );
          this.ResidualEnvironmentRisk.EnvironmentSelected = true;
        }
        if (residual.RiskPear === "Reputation") {
          const tempPear = new ReputationRisk();
          tempPear.ReputationRiskPear = residual.RiskPear;
          tempPear.ReputationRiskLikelihood = residual.RiskLikelihood;
          tempPear.ReputationRiskSeverity = residual.RiskSeverity;
          this.ResidualReputationRisk = tempPear;
          this.ResidualReputationRisk.ReputationRiskColor = this.riskService.getRiskColorClass(
            tempPear.ReputationRiskSeverity,
            tempPear.ReputationRiskLikelihood
          );
          this.ResidualReputationRisk.ReputationSelected = true;
        }
        if (residual.RiskPear === "NPT") {
          const tempPear = new NPTRisk();
          tempPear.NPTRiskPear = residual.RiskPear;
          tempPear.NPTRiskLikelihood = residual.RiskLikelihood;
          tempPear.NPTRiskSeverity = residual.RiskSeverity;
          this.ResidualNPTRisk = tempPear;
          this.ResidualNPTRisk.NPTRiskColor = this.riskService.getRiskColorClass(
            tempPear.NPTRiskSeverity,
            tempPear.NPTRiskLikelihood
          );
          this.ResidualNPTRisk.NPTSelected = true;
        }
      });

       if (response.Result.ActionDetails != null && response.Result.ActionDetails.length > 0) {
        this.actionList = response.Result.ActionDetails;
        this.actionList.forEach((element: any) => {
          element.TargetDate = moment(
            moment.utc(element.TargetDate).local()
          ).toDate();
        });
        for (let index = 0; index < this.actionList.length; index++) {
          this.ref.detectChanges();
          this.actionList[index].FilesPreview = this.actionList[index].Files;
          this.actionList[index].Files = this.actionList[index].Files;
        }
      } else {
        this.actionList = [];
        this.addAction();
      }
    
    //this.getSpecificationData(this.riskRequest.RiskRequestId);
    this.riskService.setupdatedRiskData(JSON.stringify(this.riskRequest));
    this.riskIds = this.riskService.getAllRiskIds();
    if(this.riskIds == null){
      this.isNext = false;
      this.isPrevious = false;
    }
    let currentIndex: number = 0;
    if(this.riskIds && this.riskIds.length>0)
    {
    this.riskIds.forEach((element, index) => {
      if (element.RiskRequestId === this.selectedRiskRequestId) {
        currentIndex = index;
        return;
      }
    });
    if (currentIndex === 0) {
      this.isPrevious = false;
    }
    if (currentIndex === this.riskIds.length - 1) {
      this.isNext = false;
    }
  }
  else 
  {
    this.isPrevious = false;
    this.isNext = false;
  }
}
  else 
  {
    this.notificationsService.toastNotify(
      "error",
      "Error Message",
      "This is not HEMP Risk entry."
    );
  }
  }
  else
  {
    this.notificationsService.toastNotify(
      "error",
      "Error Message",
      "Something went wrong."
    );
  }
    this.baseService.showRootLoader = false;
    this.selctedRiskId=[];
    this.selectedriskControlTechniqueId.forEach(element => {
       this.selctedRiskId.push(this.riskControlTechniqueDet.find(x=>x.Id ===element).Type);
    });
    this.riskRequest.SelectedRiskControlNames=this.selctedRiskId;
    this.riskRequest.RiskIdentifyBy = this.selectedUserEmp ? this.selectedUserEmp.FullName : "";
    this.riskService.setUpdatedData(
      JSON.stringify(this.riskRequest),
      "UpdateAction"
    );
    if(this.isImport == true)
    {
      this.getResidualMaximumRiskArea();
      this.getCurrentMaximumRiskArea();
    }
    this.isImport = false;
  }
  getIsActiveUnit(unitId) {
    
    const apiRequestUnit = {
      Model: {
        UnitId: unitId,  
      },
    };
    this.masterscreenService.getIsActiveUnit(
      apiRequestUnit,
      this.callbackMethodForgetIsActiveUnit.bind(this)
    );
  }

  callbackMethodForgetIsActiveUnit(response) {

    this.editEnabled = response.Result[0].IsActive;
    
  }
CheckValidForApprove()
{
  this.baseService.showRootLoader = true;
  const apiRequest = {
    Model: {
      RiskRequestId: this.selectedRiskRequestId,
      ApprovalLevel:this.Approval,
      UserID:this.loggedInUserJSON.UserId
    }
  };
  this.riskService.getIsValidForApprove(
    apiRequest,
    this.successIsValidForApprove.bind(this)
  );

}

successIsValidForApprove(response)
{
if(!response || response.Result===false)
     {
        this.ShowApproveButton = false;
         this.notificationsService.toastNotify(
          "error",
          "Warning Message",
          "Invalid For Approve Record."
        );   
}
}



  getSpecificationData(RiskRequestId : number) {
		const apiRequest = {
			Model: {
				SourceId: RiskRequestId,
				ModuleId: ConstantsService.PermissionMatrixModules.Risk
			}
		};
		this.commonService.getCategoryData(apiRequest, this.callbackMethodForGetSpecificationData.bind(this));
	}

	callbackMethodForGetSpecificationData(response) {
		this.lifeSavingCheckedValue = [];
	//	this.resetCategoryData();
		if (response && response.Success) {
			this.specificationResponseData = response.Result;
			if (this.specificationResponseData.ModuleId === this.moduleId && this.specificationResponseData.SourceId === this.sourceId) {
				this.isShowSpecification = true;
				this.isShowCategory = false;
				this.specificationResponseData.RuleId.forEach(checkedrule => {
					for (var i = 0; i < this.specificationData.length; i++) {
						for (var j = 0; j < this.specificationData[i].LstCategoryRuleGroupedByCategoryId.length; j++) {
							if (this.specificationData[i].LstCategoryRuleGroupedByCategoryId[j].RuleId === checkedrule) {
								this.specificationData[i].LstCategoryRuleGroupedByCategoryId[j].Checked = true;
								this.lifeSavingCheckedValue.push(checkedrule);
							}
						}
					}
				});
			}
		//	this.categoryCheckedValueEmittedData.emit(this.lifeSavingCheckedValue);
		}
	}



  getAllMasterForRaiseRisk() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        CompanyId: this.loggedInUserJSON.Company.CompanyId
      }
    };
    this.riskService.getAllMasterForRaiseRisk(
      apiRequest,
      this.getAllMasterForRaiseRiskSuccess.bind(this)
    );
  }

  getAllMasterForRaiseRiskSuccess(response: { Result: RaiseRiskAllMaster; }) {
    this.raiseRiskAllMaster = response.Result;
    this.baseService.showRootLoader = false;
    if (this.sourceId > 0) {
      this.getRiskRequestForEdit();
    }
    
  }

  // To get Employee(s) and Contractor(s) name
  getUsersOnSearch(event: { query: string; }) {
    if(!this.selectedUnit || this.selectedUnit.UnitId===0)
    {
      const filtered: any[] = [];
      this.searchedUser = new User();
      filtered.push(this.searchedUser);
      this.userResults = filtered; 
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "PLease Select Unit."
      );
      return;

    }
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.FilterTexts = event.query;
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = this.selectedUnit.UnitId;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.riskService.getSearchResultsForUsers(
      apiRequest,
      this.callbackMethodForGetSearchResultsForUsersData.bind(this)
    );
  }
  // call back method of employee on search
  callbackMethodForGetSearchResultsForUsersData(response: { Success: any; Result: string | any[]; }) {
    if (response.Success) {
      const filtered: any[] = [];
      for (let index = 0; index < response.Result.length; index++) {
        const user = response.Result[index];
        if (
          user.FullName.toLowerCase().indexOf(
            this.searchTexts.FilterTexts.toLowerCase()
          ) !== -1
        ) {
          filtered.push(user);
        }
      }
      this.userResults = filtered;
    }
  }
  getRiskColor(selectedType: any, TypeOfCategory: any) {
    switch (selectedType) {
      case RiskConstantsService.RiskType.Potential:
        switch (TypeOfCategory) {
          case "People":
            this.PotentialPeopleRisk.PeopleRiskColor = this.riskService.getRiskColorClass(
              this.PotentialPeopleRisk.PeopleRiskSeverity,
              this.PotentialPeopleRisk.PeopleRiskLikelihood
            );
            break;
          case "Assets":
            this.PotentialAssetsRisk.AssetsRiskColor = this.riskService.getRiskColorClass(
              this.PotentialAssetsRisk.AssetsRiskSeverity,
              this.PotentialAssetsRisk.AssetsRiskLikelihood
            );
            break;
          case "Environment":
            this.PotentialEnvironmentRisk.EnvironmentRiskColor = this.riskService.getRiskColorClass(
              this.PotentialEnvironmentRisk.EnvironmentRiskSeverity,
              this.PotentialEnvironmentRisk.EnvironmentRiskLikelihood
            );
            break;
          case "Reputation":
            this.PotentialReputationRisk.ReputationRiskColor = this.riskService.getRiskColorClass(
              this.PotentialReputationRisk.ReputationRiskSeverity,
              this.PotentialReputationRisk.ReputationRiskLikelihood
            );
            break;
          case "NPT":
            this.PotentialNPTRisk.NPTRiskColor = this.riskService.getRiskColorClass(
              this.PotentialNPTRisk.NPTRiskSeverity,
              this.PotentialNPTRisk.NPTRiskLikelihood
            );
            break;
        }
        break;
      case RiskConstantsService.RiskType.Residual:
        this.residualRiskColor = this.riskService.getRiskColorClass(
          this.riskRequest.ResidualRiskSeverity,
          this.riskRequest.ResidualRiskLikelihood
        );
        break;
    }
  }
  getRiskColor1(selectedType: any, TypeOfCategory: any) {
    switch (selectedType) {
      case RiskConstantsService.RiskType.Residual:
        switch (TypeOfCategory) {
          case "People":
            this.ResidualPeopleRisk.PeopleRiskColor = this.riskService.getRiskColorClass(
              this.ResidualPeopleRisk.PeopleRiskSeverity,
              this.ResidualPeopleRisk.PeopleRiskLikelihood
            );
            break;
          case "Assets":
            this.ResidualAssetsRisk.AssetsRiskColor = this.riskService.getRiskColorClass(
              this.ResidualAssetsRisk.AssetsRiskSeverity,
              this.ResidualAssetsRisk.AssetsRiskLikelihood
            );
            break;
          case "Environment":
            this.ResidualEnvironmentRisk.EnvironmentRiskColor = this.riskService.getRiskColorClass(
              this.ResidualEnvironmentRisk.EnvironmentRiskSeverity,
              this.ResidualEnvironmentRisk.EnvironmentRiskLikelihood
            );
            break;
          case "Reputation":
            this.ResidualReputationRisk.ReputationRiskColor = this.riskService.getRiskColorClass(
              this.ResidualReputationRisk.ReputationRiskSeverity,
              this.ResidualReputationRisk.ReputationRiskLikelihood
            );
            break;
          case "NPT":
            this.ResidualNPTRisk.NPTRiskColor = this.riskService.getRiskColorClass(
              this.ResidualNPTRisk.NPTRiskSeverity,
              this.ResidualNPTRisk.NPTRiskLikelihood
            );
            break;
        }
        this.getResidualMaximumRiskArea();
        break;
      case RiskConstantsService.RiskType.Potential:
        this.potentialRiskColor = this.riskService.getRiskColorClass(
          this.riskRequest.ResidualRiskSeverity,
          this.riskRequest.ResidualRiskLikelihood
        );
        break;
    }
  }

  getResidualMaximumRiskArea()
  {    
    
            this.ResidualPeopleRisk.PeopleRiskColor = this.riskService.getRiskColorClass(
              this.ResidualPeopleRisk.PeopleRiskSeverity,
              this.ResidualPeopleRisk.PeopleRiskLikelihood
            );
           
            this.ResidualAssetsRisk.AssetsRiskColor = this.riskService.getRiskColorClass(
              this.ResidualAssetsRisk.AssetsRiskSeverity,
              this.ResidualAssetsRisk.AssetsRiskLikelihood
            );
            
            this.ResidualEnvironmentRisk.EnvironmentRiskColor = this.riskService.getRiskColorClass(
              this.ResidualEnvironmentRisk.EnvironmentRiskSeverity,
              this.ResidualEnvironmentRisk.EnvironmentRiskLikelihood
            );
          
            this.ResidualReputationRisk.ReputationRiskColor = this.riskService.getRiskColorClass(
              this.ResidualReputationRisk.ReputationRiskSeverity,
              this.ResidualReputationRisk.ReputationRiskLikelihood
            );
            
            this.ResidualNPTRisk.NPTRiskColor = this.riskService.getRiskColorClass(
              this.ResidualNPTRisk.NPTRiskSeverity,
              this.ResidualNPTRisk.NPTRiskLikelihood
            );

            this.ResidualP = this.ResidualPeopleRisk.PeopleRiskColor;
            this.ResidualE = this.ResidualEnvironmentRisk.EnvironmentRiskColor;
            this.ResidualA = this.ResidualAssetsRisk.AssetsRiskColor;
            this.ResidualR = this.ResidualReputationRisk.ReputationRiskColor;
            this.ResidualN = this.ResidualNPTRisk.NPTRiskColor;

            var ResidualColors = [
              {
                  id: "1",
                  name: "P",
                  color: this.ResidualP
              },
              {
                id: "2",
                name: "E",
                color: this.ResidualE
              },
              {
                  id: "3",
                  name: "A",
                  color: this.ResidualA
              },
              {
                id: "4",
                name: "R",
                color: this.ResidualR
            },
            {
              id: "5",
              name: "N",
              color: this.ResidualN
          }
          ];
          
            let highRisk = ResidualColors.filter(s => s.color == 'riskColorRed').map(s => s.name).toString();
            let mediumRisk = ResidualColors.filter(s => s.color == 'riskColorYellow').map(s => s.name).toString();
            let lowRisk = ResidualColors.filter(s => s.color == 'riskColorBlue').map(s => s.name).toString();
            
            //Check if all risks are of same priority
            if(this.ResidualP  === this.ResidualE && this.ResidualP  === this.ResidualA && this.ResidualP  === this.ResidualR
              && this.ResidualP  === this.ResidualN && (this.ResidualP === "riskColorRed" || this.ResidualP === "riskColorYellow" || this.ResidualP === "riskColorBlue"))
              {
                this.riskRequest.RiskRequestHEMP.ResidualMaximumRiskArea = "P,E,A,R,N";
              }
              //Check for High risk
              else if(this.ResidualP === "riskColorRed" || this.ResidualE === "riskColorRed" || this.ResidualA === "riskColorRed"
              || this.ResidualR === "riskColorRed" || this.ResidualN === "riskColorRed" )
              {
                this.riskRequest.RiskRequestHEMP.ResidualMaximumRiskArea = highRisk;
              }
               //Check for Medium risk
               else if(this.ResidualP === "riskColorYellow" || this.ResidualE === "riskColorYellow" || this.ResidualA === "riskColorYellow"
               || this.ResidualR === "riskColorYellow" || this.ResidualN === "riskColorYellow" )
               {
                 this.riskRequest.RiskRequestHEMP.ResidualMaximumRiskArea = mediumRisk;
               }
               //Check for Low risk
               else if(this.ResidualP === "riskColorBlue" || this.ResidualE === "riskColorBlue" || this.ResidualA === "riskColorBlue"
                || this.ResidualR === "riskColorBlue" || this.ResidualN === "riskColorBlue" )
               {
                   this.riskRequest.RiskRequestHEMP.ResidualMaximumRiskArea = lowRisk;
               }
               else
               {
                   this.riskRequest.RiskRequestHEMP.ResidualMaximumRiskArea = "";
               }

  }

  getRiskAssessmentColor(selectedType: any, TypeOfCategory: any) {
    switch (selectedType) {
      case RiskConstantsService.RiskType.Residual:
        switch (TypeOfCategory) {
          case "People":
            this.RiskassessmentPeople.PeopleRiskColor = this.riskService.getRiskColorClass(
              this.RiskassessmentPeople.PeopleRiskSeverity,
              this.RiskassessmentPeople.PeopleRiskLikelihood
            );
            break;
          case "Assets":
            this.RiskassessmentAssets.AssetsRiskColor = this.riskService.getRiskColorClass(
              this.RiskassessmentAssets.AssetsRiskSeverity,
              this.RiskassessmentAssets.AssetsRiskLikelihood
            );
            break;
          case "Environment":
            this.RiskassessmentEnvironment.EnvironmentRiskColor = this.riskService.getRiskColorClass(
              this.RiskassessmentEnvironment.EnvironmentRiskSeverity,
              this.RiskassessmentEnvironment.EnvironmentRiskLikelihood
            );
            break;
          case "Reputation":
            this.RiskassessmentReputation.ReputationRiskColor = this.riskService.getRiskColorClass(
              this.RiskassessmentReputation.ReputationRiskSeverity,
              this.RiskassessmentReputation.ReputationRiskLikelihood
            );
            break;
          case "NPT":
            this.RiskassessmentNPT.NPTRiskColor = this.riskService.getRiskColorClass(
              this.RiskassessmentNPT.NPTRiskSeverity,
              this.RiskassessmentNPT.NPTRiskLikelihood
            );
            break;
        }
        this.getCurrentMaximumRiskArea();
        break;
      case RiskConstantsService.RiskType.Potential:
        this.potentialRiskColor = this.riskService.getRiskColorClass(
          this.riskRequest.ResidualRiskSeverity,
          this.riskRequest.ResidualRiskLikelihood
        );
        break;
    }
  }
  getCurrentMaximumRiskArea()
  {
      this.RiskassessmentPeople.PeopleRiskColor = this.riskService.getRiskColorClass(
        this.RiskassessmentPeople.PeopleRiskSeverity,
        this.RiskassessmentPeople.PeopleRiskLikelihood
      );
      this.RiskassessmentAssets.AssetsRiskColor = this.riskService.getRiskColorClass(
        this.RiskassessmentAssets.AssetsRiskSeverity,
        this.RiskassessmentAssets.AssetsRiskLikelihood
      );
      this.RiskassessmentEnvironment.EnvironmentRiskColor = this.riskService.getRiskColorClass(
        this.RiskassessmentEnvironment.EnvironmentRiskSeverity,
        this.RiskassessmentEnvironment.EnvironmentRiskLikelihood
      );
      this.RiskassessmentReputation.ReputationRiskColor = this.riskService.getRiskColorClass(
        this.RiskassessmentReputation.ReputationRiskSeverity,
        this.RiskassessmentReputation.ReputationRiskLikelihood
      ); 
      this.RiskassessmentNPT.NPTRiskColor = this.riskService.getRiskColorClass(
        this.RiskassessmentNPT.NPTRiskSeverity,
        this.RiskassessmentNPT.NPTRiskLikelihood
      );

      this.CurrentP = this.RiskassessmentPeople.PeopleRiskColor;
      this.CurrentE = this.RiskassessmentEnvironment.EnvironmentRiskColor;
      this.CurrentA = this.RiskassessmentAssets.AssetsRiskColor;
      this.CurrentR = this.RiskassessmentReputation.ReputationRiskColor;
      this.CurrentN = this.RiskassessmentNPT.NPTRiskColor;

      var CurrentRiskColors = [
        {
            id: "1",
            name: "P",
            color: this.CurrentP
        },
        {
          id: "2",
          name: "E",
          color: this.CurrentE
        },
        {
            id: "3",
            name: "A",
            color: this.CurrentA
        },
        {
          id: "4",
          name: "R",
          color: this.CurrentR
      },
      {
        id: "5",
        name: "N",
        color: this.CurrentN
    }
    ];
    
      let highRisk = CurrentRiskColors.filter(s => s.color == 'riskColorRed').map(s => s.name).toString();
      let mediumRisk = CurrentRiskColors.filter(s => s.color == 'riskColorYellow').map(s => s.name).toString();
      let lowRisk = CurrentRiskColors.filter(s => s.color == 'riskColorBlue').map(s => s.name).toString();
      
      //Check if all risks are of same priority
      if(this.CurrentP  === this.CurrentE && this.CurrentP  === this.CurrentA && this.CurrentP  === this.CurrentR
        && this.CurrentP  === this.CurrentN && (this.CurrentP === "riskColorRed" || this.CurrentP === "riskColorYellow" || this.CurrentP === "riskColorBlue"))
        {
          this.riskRequest.RiskRequestHEMP.ResidualMaximumRiskArea = "P,E,A,R,N";
        }
        //Check for High risk
        else if(this.CurrentP === "riskColorRed" || this.CurrentE === "riskColorRed" || this.CurrentA === "riskColorRed"
        || this.CurrentR === "riskColorRed" || this.CurrentN === "riskColorRed" )
        {
          this.riskRequest.RiskRequestHEMP.CurrentMaximumRiskArea = highRisk;
        }
         //Check for Medium risk
         else if(this.CurrentP === "riskColorYellow" || this.CurrentE === "riskColorYellow" || this.CurrentA === "riskColorYellow"
         || this.CurrentR === "riskColorYellow" || this.CurrentN === "riskColorYellow" )
         {
           this.riskRequest.RiskRequestHEMP.CurrentMaximumRiskArea = mediumRisk;
         }
         //Check for Low risk
         else if(this.CurrentP === "riskColorBlue" || this.CurrentE === "riskColorBlue" || this.CurrentA === "riskColorBlue"
          || this.CurrentR === "riskColorBlue" || this.CurrentN === "riskColorBlue" )
         {
             this.riskRequest.RiskRequestHEMP.CurrentMaximumRiskArea = lowRisk;
         }
         else
         {
             this.riskRequest.RiskRequestHEMP.CurrentMaximumRiskArea = "";
         }

  }

  removeActionFromActionList(index: number) {
    if (this.actionList.length > 1) {
      this.actionList.splice(index, 1);
    }
  }
  addAction() {
    this.actionPost = new AssignActionPost();
    this.actionList.push(this.actionPost);
  }
  raiseRiskHEMP() {
    if (this.validateForm()) {
      const raiseRisk = new RaiseRisk();
      this.baseService.showRootLoader = true;
      this.bindActionOwnerIdToList();
      this.createPEARList();
      this.raiseRisk.RiskRequest.UnitId = parseInt(this.selectedUnit.UnitId);
      this.raiseRisk.RiskRequest.IsDraft = false;
      this.raiseRisk.RiskRequest.ContractId  = this.isEmployeeUnit?0: this.selectedContractId;
      this.raiseRisk.RiskRequest.RiskId = this.selectedRiskRequestId;
      this.raiseRisk.RiskRequest.RiskManagementToolId = ConstantsService.RiskManagementTool.HEMP;
      // if(this.raiseRisk.RiskRequest.RiskRequestMOC.RiskMovementId == 1){this.riskMovementText = "Increasing"}
      // else if(this.raiseRisk.RiskRequest.RiskRequestMOC.RiskMovementId == 2){this.riskMovementText = "Decreasing"}
      // else if(this.raiseRisk.RiskRequest.RiskRequestMOC.RiskMovementId == 3){this.riskMovementText = "Stable"}
      this.raiseRisk.RiskRequest.RiskMovement = "";
      this.raiseRisk.RiskRequest.RiskIdentifiedBy = this.selectedUserEmp.UserId;
      this.raiseRisk.RiskRequest.RiskRequestHEMP.RiskOwnerPartyId = this.selectedUserForRiskOwner.UserId; 
      this.raiseRisk.RiskRequest.RiskRequestHEMP.SelectedriskControlTechniqueIds = this.selectedriskControlTechniqueId;
      this.raiseRisk.RiskRequest.RiskRequestHEMP.RiskRequestPreventiveActions=this.PreventiveActionsList;
      this.raiseRisk.RiskRequest.RiskRequestHEMP.RiskRequestMitigativePlan=this.MitigativePlansList;
      const apiRequest = {
        Model: this.raiseRisk
      };
      this.riskService.raiseRiskForSelectedTool(apiRequest, this.raiseRiskSuccess.bind(this));
    }
    else {
      this.baseService.showRootLoader = false;
    }
  }
  bindActionOwnerIdToList() {
    if (this.riskPermission.RSK_Admin || this.riskPermission.RSK_Admin_Unit) {
      this.actionList.forEach((action: { ActionPartyId: any; selectedActionParty: { UserId: any; }; ActionOwnerId: any; ActionOwner: { UserId: any; }; UnitId: number; }) => {
        action.ActionPartyId = action.selectedActionParty.UserId;
        action.ActionOwnerId = action.ActionOwner.UserId;
        action.UnitId = parseInt(this.selectedUnit);
      });
    }
  }
  selectActionOwner(event: { UserId: any; FullName: any; Email: any; FirstName: any; LastName: any; UserTypeId: any; UserTypes: any; ContactNumber: any; Designation: any; DepartmentName: any; }, index: string | number) {
    if (!event.UserId) {
      this.actionList[index].ActionOwner.UserId = 0;
    } else {
      this.actionList[index].selectedActionParty = new User();
      // this.actionList[index].selectedActionParty = {
      //   UserId: event.UserId,
      //   FullName: event.FullName,
      //   Email: event.Email,
      //   FirstName: event.FirstName,
      //   LastName: event.LastName,
      //   UserTypeId: event.UserTypeId,
      //   UserTypes: event.UserTypes,
      //   ContactNumber: event.ContactNumber,
      //   Designation: event.Designation,
      //   DepartmentName: event.DepartmentName
      // };
      this.actionList[index].ShowActionOwnerErrorMessage = false;
    }
  }
  selectActionParty(event: { UserId: any; }, index: string | number) {
    if (!event.UserId) {
      this.actionList[index].ActionParty.UserId = 0;
    } else {
      this.actionList[index].ShowActionPartyErrorMessage = false;
    }
  }
  raiseRiskSuccess(response: { Success: any; Result: number; Errors: null; }) {
    if (response && response.Success) {
      if (this.riskRequest.RiskRequestId === 0) {
        this.raiseRisk.RiskRequest.RiskRequestId = response.Result;
        //this.trackDetails(this.raiseRisk);
      }      
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Risk details has been added successfully"
      );
      this.router.navigate([RiskConstantsService.RedirectUrls.MyRiskRequest]);
      this.savePDF(response.Result);
      if (this.actionList.length > 0) {
        this.updateAction();
      }
      if (this.lifeSavingCheckedValueData.length > 0) {
        this.submitSpecificationData();
      }
       // reset form fields
      // this.resetForm();
    }
    if (response.Errors !== null) {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong."
      );
      // this.alertType = ConstantsService.Error;
      // this.errorDetails = response.Errors;
    }
    this.baseService.showRootLoader = false;
  }

  onYesClickedSuccess() {
    switch (this.alertFrom) {
      case "RaiseUpdate":
        this.router.navigate([RiskConstantsService.RedirectUrls.MyRiskRequest]);
        break;
    }
    this.alertType = "";
    this.errorDetails = null;
    this.successDetails = "";
  }

  validateForm() {
    this.baseService.showRootLoader = true;
    let isFormValid = true;
    this.unitError = true;
    if (this.selectedUnit != undefined) {
    if (this.selectedUnit.UnitId) {

      this.unitError = false;

      isFormValid = true;

    }
    }
    if (this.selectedUserEmp && this.selectedUserEmp.UserId == 0) {
      this.isRiskReportErrorMsg = true;
      isFormValid = false;
    }
    if (this.selectedUserForRiskOwner && this.selectedUserForRiskOwner.UserId == 0) {
      this.isRiskOwnerPartyErrorMsg = true;
      isFormValid = false;
    }
    if (!this.selectedriskControlTechniqueId.length) {
      this.riskControlTechniqueErrorMsg = true;
      isFormValid = false;
    }
    if (
      this.riskRequest.RiskSourceId === 0 ||
      this.riskRequest.RiskSourceId.toString() === "0"
    ) {
      this.displayErrorMessage.showRiskSourceErrorMessage = true;
      isFormValid = false;
    }
    // if (
    //   this.riskRequest.ProjectId === 0 ||
    //   this.riskRequest.ProjectId.toString() === "0"
    // ) {
    //   this.displayErrorMessage.showProjectNameErrorMessage = true;
    //   isFormValid = false;
    // }
    if (!this.riskRequest.LocationId) {
      this.displayErrorMessage.showLocationErrorMessage = true;
      isFormValid = false;
    }
    // if (
    //   this.riskRequest.ExactLocation == undefined || this.riskRequest.ExactLocation == ""
    // ) {
    //   this.displayErrorMessage.showExactLocationErrorMessage = true;
    //   isFormValid = false;
    // }
    if (this.riskRequest.RiskTitle.trim() === "") {
      this.displayErrorMessage.showRiskTitleErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.ActivityLeadingToHazard.trim() === "") {
      this.displayErrorMessage.showActivityLeadingToHazardErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.HazardIdentified.trim() === "") {
      this.displayErrorMessage.showHazardIdentifiedErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.ThreatIdentified.trim() === "") {
      this.displayErrorMessage.showThreatIdentifiedErrorMessage = true;
      isFormValid = false;
    }
    // if (this.riskRequest.Consequences.trim() === "") {
    //   this.displayErrorMessage.showConsequencesErrorMessage = true;
    //   isFormValid = false;
    // }
    if (this.riskRequest.PotentialRiskPear.trim() === "0") {
      this.displayErrorMessage.showPotentialPearErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.PotentialRiskLikelihood.trim() === "0") {
      this.displayErrorMessage.showPotentialConsequencesErrorMessage = true;
      isFormValid = false;
    }
    if (
      this.riskRequest.PotentialRiskSeverity === 0 ||
      this.riskRequest.PotentialRiskSeverity.toString() === "0"
    ) {
      this.displayErrorMessage.showPotentialSeverityErrorMessage = true;
      isFormValid = false;
    }
    // if (this.riskRequest.RiskOwnerParty.trim() === "") {
    //   this.displayErrorMessage.showRiskOwnerPartyErrorMessage = true;
    //   isFormValid = false;
    // }
    // if (this.riskRequest.RiskRequestHEMP.Activity.trim() === "") {
    //   this.displayErrorMessage.showHEMPActivityErrorMessage = true;
    //   isFormValid = false;
    // }
    // if (this.riskRequest.RiskRequestHEMP.HazardAssociatedWithActivity.trim() === "") {
    //   this.displayErrorMessage.showHazardAssociatedErrorMessage = true;
    //   isFormValid = false;
    // }
    if (this.riskRequest.RiskRequestHEMP.RiskThreats.trim() === "") {
      this.displayErrorMessage.showHEMPThreatsErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.RiskRequestHEMP.RiskEvents.trim() === "") {
      this.displayErrorMessage.showHEMPEventsErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.RiskRequestHEMP.RiskConsequences.trim() === "") {
      this.displayErrorMessage.showHEMPConsequencesErrorMessage = true;
      isFormValid = false;
    }
    // if (this.riskRequest.RiskRequestHEMP.PreventiveAction.trim() === "") {
    //   this.displayErrorMessage.showHEMPPreventiveActionErrorMessage = true;
    //   isFormValid = false;
    // }
    // if (this.riskRequest.RiskRequestHEMP.MitigativePlan.trim() === "") {
    //   this.displayErrorMessage.showMitigativePlanErrorMessage = true;
    //   isFormValid = false;
    // }
    if (this.riskRequest.RiskRequestHEMP.ReferenceToStandards.trim() === "") {
      this.displayErrorMessage.showReferencetoStandardsErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.ResidualRiskPear.trim() === "0") {
      this.displayErrorMessage.showResidualPearErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.ResidualRiskLikelihood.trim() === "0") {
      this.displayErrorMessage.showResidualConsequenceErrorMessage = true;
      isFormValid = false;
    }
    if (
      this.riskRequest.ResidualRiskSeverity === 0 ||
      this.riskRequest.ResidualRiskSeverity.toString() === "0"
    ) {
      this.displayErrorMessage.showResidualSeverityErrorMessage = true;
      isFormValid = false;
    }
    // //validation messages for Potential PEAR
    // if (this.riskPermission.RSK_PotentialRiskIdentified_Edit || this.riskPermission.RSK_PotentialRiskIdentified_Edit_Unit) {
    //   if (this.PotentialPeopleRisk.PeopleRiskSeverity === 0 || this.PotentialPeopleRisk.PeopleRiskSeverity.toString() === '0') {
    //     this.ShowPeopleSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialPeopleRisk.PeopleRiskLikelihood.trim() === '0') {
    //     this.ShowPeopleLikelihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialEnvironmentRisk.EnvironmentRiskSeverity === 0 || this.PotentialEnvironmentRisk.EnvironmentRiskSeverity.toString() === '0') {
    //     this.ShowEnvironmentSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialEnvironmentRisk.EnvironmentRiskLikelihood.trim() === '0') {
    //     this.ShowEnvironmentlihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialAssetsRisk.AssetsRiskSeverity === 0 || this.PotentialAssetsRisk.AssetsRiskSeverity.toString() === '0') {
    //     this.ShowAssetsSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialAssetsRisk.AssetsRiskLikelihood.trim() === '0') {
    //     this.ShowAssetslihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialReputationRisk.ReputationRiskSeverity === 0 || this.PotentialReputationRisk.ReputationRiskSeverity.toString() === '0') {
    //     this.ShowReputationSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialReputationRisk.ReputationRiskLikelihood.trim() === '0') {
    //     this.ShowReputationlihooodMessage = true;
    //     isFormValid = false;
    //   }
    // }
    // //validation messages for residual PEAR
    // if (this.riskPermission.RSK_ResidualRiskIdentified_Edit || this.riskPermission.RSK_ResidualRiskIdentified_Edit_Unit) {
    //   if (this.ResidualPeopleRisk.PeopleRiskSeverity === 0 || this.ResidualPeopleRisk.PeopleRiskSeverity.toString() === '0') {
    //     this.residualPeopleSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualPeopleRisk.PeopleRiskLikelihood.trim() === '0') {
    //     this.residualPeopleLikelihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualEnvironmentRisk.EnvironmentRiskSeverity === 0 || this.ResidualEnvironmentRisk.EnvironmentRiskSeverity.toString() === '0') {
    //     this.residualEnvironmentSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualEnvironmentRisk.EnvironmentRiskLikelihood.trim() === '0') {
    //     this.residualEnvironmentlihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualAssetsRisk.AssetsRiskSeverity === 0 || this.ResidualAssetsRisk.AssetsRiskSeverity.toString() === '0') {
    //     this.residualAssetsSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualAssetsRisk.AssetsRiskLikelihood.trim() === '0') {
    //     this.residualAssetslihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualReputationRisk.ReputationRiskSeverity === 0 || this.ResidualReputationRisk.ReputationRiskSeverity.toString() === '0') {
    //     this.residualReputationSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualReputationRisk.ReputationRiskLikelihood.trim() === '0') {
    //     this.residualReputationlihooodMessage = true;
    //     isFormValid = false;
    //   }
    // }
    // //validation messages for Assessment PEAR
    // if (this.riskPermission.RSK_CurrentRiskAssessment_Identified_Edit || this.riskPermission.RSK_CurrentRiskAssessment_Identified_Edit_Unit) {
    //   if (this.RiskassessmentPeople.PeopleRiskSeverity === 0 || this.RiskassessmentPeople.PeopleRiskSeverity.toString() === '0') {
    //     this.assessmentPeopleSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentPeople.PeopleRiskLikelihood.trim() === '0') {
    //     this.assessmentPeopleLikelihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentEnvironment.EnvironmentRiskSeverity === 0 || this.RiskassessmentEnvironment.EnvironmentRiskSeverity.toString() === '0') {
    //     this.assessmentEnvironmentSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentEnvironment.EnvironmentRiskLikelihood.trim() === '0') {
    //     this.assessmentEnvironmentlihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentAssets.AssetsRiskSeverity === 0 || this.RiskassessmentAssets.AssetsRiskSeverity.toString() === '0') {
    //     this.assessmentAssetsSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentAssets.AssetsRiskLikelihood.trim() === '0') {
    //     this.assessmentAssetslihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentReputation.ReputationRiskSeverity === 0 || this.RiskassessmentReputation.ReputationRiskSeverity.toString() === '0') {
    //     this.assessmentReputationSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentReputation.ReputationRiskLikelihood.trim() === '0') {
    //     this.assessmentReputationlihooodMessage = true;
    //     isFormValid = false;
    //   }
    // }
    // Action error messages
    if (this.riskPermission.RSK_Admin || this.riskPermission.RSK_Admin_Unit) {
      if (this.actionList[0].Action !== "") {
        this.actionList.forEach((action: { Action: string; ShowActionErrorMessage: boolean; ActionOwner: { UserId: number; }; ShowActionOwnerErrorMessage: boolean; selectedActionParty: { UserId: number; }; ShowActionPartyErrorMessage: boolean; Priority: number; ShowPriorityErrorMessage: boolean; TargetDate: any; ShowTargetErrorMessage: boolean; }) => {
          if (action.Action.trim() === "") {
            action.ShowActionErrorMessage = true;
            isFormValid = false;
          }
          if (action.ActionOwner.UserId == 0) {
            action.ShowActionOwnerErrorMessage = true;
            isFormValid = false;
          }
          if (action.selectedActionParty.UserId == 0) {
            action.ShowActionPartyErrorMessage = true;
            isFormValid = false;
          }
          if (action.Priority === 0) {
            action.ShowPriorityErrorMessage = true;
            isFormValid = false;
          }
          if (!action.TargetDate) {
            action.ShowTargetErrorMessage = true;
            isFormValid = false;
          }
        });
      }
    }

      //Preventive Action Error messages
      if(this.PreventiveActionsList != null && this.PreventiveActionsList.length > 0)
      {
        this.PreventiveActionsList.forEach((action: { PreventiveAction: string; ShowPreventiveActionErrorMessage: boolean; }) => {
          if (action.PreventiveAction.trim() === "") {
            action.ShowPreventiveActionErrorMessage = true;
            isFormValid = false;
          }       
        });
      }
       //Mitigative Plan Error messages
       if(this.MitigativePlansList != null && this.MitigativePlansList.length > 0)
       {
         this.MitigativePlansList.forEach((action: { MitigativePlan: string; ShowMitigativePlanErrorMessage: boolean; }) => {
           if (action.MitigativePlan.trim() === "") {
             action.ShowMitigativePlanErrorMessage = true;
             isFormValid = false;
           }       
         });
       }
        
    return isFormValid;
  }
  confirmResetForm() {
    this.alertType = ConstantsService.Confirm;
    this.confirmMessage =
      "You have clicked reset button. All information " +
      "entered by you on this page will be lost. Do you want to reset the form?";
  }
  onYesClickedForConfirmation() {
    this.resetForm();
    this.alertType = "";
    this.confirmMessage = "";
  }
  onNoClickedForConfirmation() {
    this.alertType = "";
    this.confirmMessage = "";
  }
  resetForm() {
    this.selectedUserEmp = new User();
    this.selectedUserForRiskOwner = new User();
    this.displayErrorMessage = new RaiseRiskShowErrorMessages();
    this.riskRequest = new RiskRequest();
    this.riskRequest.RiskRequestHEMP = new RiskRequestHEMP();
    this.actionPost = new AssignActionPost();
    this.actionList = [];
    this.PotentialPeopleRisk = new PeopleRisk();
    this.PotentialEnvironmentRisk = new EnvironmentRisk();
    this.PotentialAssetsRisk = new AssetsRisk();
    this.PotentialReputationRisk = new ReputationRisk();
    this.PotentialNPTRisk = new NPTRisk();
    this.ResidualPeopleRisk = new PeopleRisk();
    this.ResidualAssetsRisk = new AssetsRisk();
    this.ResidualEnvironmentRisk = new EnvironmentRisk();
    this.ResidualReputationRisk = new ReputationRisk();
    this.ResidualNPTRisk = new NPTRisk();
    this.RiskassessmentPeople = new PeopleRisk();
    this.RiskassessmentEnvironment = new EnvironmentRisk();
    this.RiskassessmentAssets = new AssetsRisk();
    this.RiskassessmentReputation = new ReputationRisk();
    this.RiskassessmentReputation.ReputationSelected = false;
    this.RiskassessmentNPT = new NPTRisk();
    this.RiskassessmentNPT.NPTSelected = false;
    this.actionList.push(this.actionPost);
    this.searchTexts = new SearchText();
    this.selectedriskControlTechniqueId = [];
    this.riskControlTechnique.forEach(element => {
      element.Checked = false;
    });
    window.open(ConstantsService.URL.APP + ['/risk/raise-risk-hemp/new'], '_self');
  }
  updateRisk() {
    if (this.validateForm()) {
      this.baseService.showRootLoader = true;
      const raiseRisk = new RaiseRisk();
      this.UpdatedPotentialPear = [];
      this.UpdatedResidualPear = [];
      this.UpdatedAssessmentPear = [];
      raiseRisk.RiskRequest = this.riskRequest;
     raiseRisk.RiskRequest.ContractId = this.isEmployeeUnit?0: this.selectedContractId;
      if (this.PotentialPeopleRisk) {
        const tempPear = new PearDetails();
        tempPear.RiskPear = this.PotentialPeopleRisk.PeopleRiskPear;
        tempPear.RiskSeverity = this.PotentialPeopleRisk.PeopleRiskSeverity;
        tempPear.RiskLikelihood = this.PotentialPeopleRisk.PeopleRiskLikelihood;
        this.UpdatedPotentialPear.push(tempPear);
        raiseRisk.PotentialPEARList = this.UpdatedPotentialPear;
        this.riskRequest.PotentialPEARList=this.UpdatedPotentialPear;
      }
      if (this.PotentialEnvironmentRisk) {
        const tempEnvironmentPear = new PearDetails();
        tempEnvironmentPear.RiskPear = this.PotentialEnvironmentRisk.EnvironmentRiskPear;
        tempEnvironmentPear.RiskSeverity = this.PotentialEnvironmentRisk.EnvironmentRiskSeverity;
        tempEnvironmentPear.RiskLikelihood = this.PotentialEnvironmentRisk.EnvironmentRiskLikelihood;
        this.UpdatedPotentialPear.push(tempEnvironmentPear);
        raiseRisk.PotentialPEARList = this.UpdatedPotentialPear;
        this.riskRequest.PotentialPEARList=this.UpdatedPotentialPear;
      }
      if (this.PotentialAssetsRisk) {
        const tempAssetsPear = new PearDetails();
        tempAssetsPear.RiskPear = this.PotentialAssetsRisk.AssetsRiskPear;
        tempAssetsPear.RiskSeverity = this.PotentialAssetsRisk.AssetsRiskSeverity;
        tempAssetsPear.RiskLikelihood = this.PotentialAssetsRisk.AssetsRiskLikelihood;
        this.UpdatedPotentialPear.push(tempAssetsPear);
        raiseRisk.PotentialPEARList = this.UpdatedPotentialPear;
        this.riskRequest.PotentialPEARList=this.UpdatedPotentialPear;
      }
      if (this.PotentialReputationRisk) {
        const tempReputationPear = new PearDetails();
        tempReputationPear.RiskPear = this.PotentialReputationRisk.ReputationRiskPear;
        tempReputationPear.RiskSeverity = this.PotentialReputationRisk.ReputationRiskSeverity;
        tempReputationPear.RiskLikelihood = this.PotentialReputationRisk.ReputationRiskLikelihood;
        this.UpdatedPotentialPear.push(tempReputationPear);
        raiseRisk.PotentialPEARList = this.UpdatedPotentialPear;
        this.riskRequest.PotentialPEARList=this.UpdatedPotentialPear;
      }
      if (this.PotentialNPTRisk) {
        const tempNPTPear = new PearDetails();
        tempNPTPear.RiskPear = this.PotentialNPTRisk.NPTRiskPear;
        tempNPTPear.RiskSeverity = this.PotentialNPTRisk.NPTRiskSeverity;
        tempNPTPear.RiskLikelihood = this.PotentialNPTRisk.NPTRiskLikelihood;
        this.UpdatedPotentialPear.push(tempNPTPear);
        raiseRisk.PotentialPEARList = this.UpdatedPotentialPear;
        this.riskRequest.PotentialPEARList=this.UpdatedPotentialPear;
      }
      if (this.ResidualPeopleRisk) {
        const residualPear = new PearDetails();
        residualPear.RiskPear = this.ResidualPeopleRisk.PeopleRiskPear;
        residualPear.RiskSeverity = this.ResidualPeopleRisk.PeopleRiskSeverity;
        residualPear.RiskLikelihood = this.ResidualPeopleRisk.PeopleRiskLikelihood;
        this.UpdatedResidualPear.push(residualPear);
        raiseRisk.ResidualPEARList = this.UpdatedResidualPear;
        this.riskRequest.ResidualPEARList=this.UpdatedResidualPear;
      }
      if (this.ResidualEnvironmentRisk) {
        const residualEnvPear = new PearDetails();
        residualEnvPear.RiskPear = this.ResidualEnvironmentRisk.EnvironmentRiskPear;
        residualEnvPear.RiskSeverity = this.ResidualEnvironmentRisk.EnvironmentRiskSeverity;
        residualEnvPear.RiskLikelihood = this.ResidualEnvironmentRisk.EnvironmentRiskLikelihood;
        this.UpdatedResidualPear.push(residualEnvPear);
        raiseRisk.ResidualPEARList = this.UpdatedResidualPear;
        this.riskRequest.ResidualPEARList=this.UpdatedResidualPear;
      }
      if (this.ResidualAssetsRisk) {
        const residualAssetsPear = new PearDetails();
        residualAssetsPear.RiskPear = this.ResidualAssetsRisk.AssetsRiskPear;
        residualAssetsPear.RiskSeverity = this.ResidualAssetsRisk.AssetsRiskSeverity;
        residualAssetsPear.RiskLikelihood = this.ResidualAssetsRisk.AssetsRiskLikelihood;
        this.UpdatedResidualPear.push(residualAssetsPear);
        raiseRisk.ResidualPEARList = this.UpdatedResidualPear;
        this.riskRequest.ResidualPEARList=this.UpdatedResidualPear;
      }
      if (this.ResidualReputationRisk) {
        const residualReputationPear = new PearDetails();
        residualReputationPear.RiskPear = this.ResidualReputationRisk.ReputationRiskPear;
        residualReputationPear.RiskSeverity = this.ResidualReputationRisk.ReputationRiskSeverity;
        residualReputationPear.RiskLikelihood = this.ResidualReputationRisk.ReputationRiskLikelihood;
        this.UpdatedResidualPear.push(residualReputationPear);
        raiseRisk.ResidualPEARList = this.UpdatedResidualPear;
        this.riskRequest.ResidualPEARList=this.UpdatedResidualPear;
      }
      if (this.ResidualNPTRisk) {
        const residualNPTPear = new PearDetails();
        residualNPTPear.RiskPear = this.ResidualNPTRisk.NPTRiskPear;
        residualNPTPear.RiskSeverity = this.ResidualNPTRisk.NPTRiskSeverity;
        residualNPTPear.RiskLikelihood = this.ResidualNPTRisk.NPTRiskLikelihood;
        this.UpdatedResidualPear.push(residualNPTPear);
        raiseRisk.ResidualPEARList = this.UpdatedResidualPear;
        this.riskRequest.ResidualPEARList=this.UpdatedResidualPear;
      }
      if (this.RiskassessmentPeople) {
        const assessmentPear = new PearDetails();
        assessmentPear.RiskPear = this.RiskassessmentPeople.PeopleRiskPear;
        assessmentPear.RiskSeverity = this.RiskassessmentPeople.PeopleRiskSeverity;
        assessmentPear.RiskLikelihood = this.RiskassessmentPeople.PeopleRiskLikelihood;
        this.UpdatedAssessmentPear.push(assessmentPear);
        raiseRisk.RiskAssessmentPEARList = this.UpdatedAssessmentPear;
        this.riskRequest.RiskAssessmentPEARList=this.UpdatedAssessmentPear;
      }
      if (this.RiskassessmentEnvironment) {
        const assessmentEnvPear = new PearDetails();
        assessmentEnvPear.RiskPear = this.RiskassessmentEnvironment.EnvironmentRiskPear;
        assessmentEnvPear.RiskSeverity = this.RiskassessmentEnvironment.EnvironmentRiskSeverity;
        assessmentEnvPear.RiskLikelihood = this.RiskassessmentEnvironment.EnvironmentRiskLikelihood;
        this.UpdatedAssessmentPear.push(assessmentEnvPear);
        raiseRisk.RiskAssessmentPEARList = this.UpdatedAssessmentPear;
        this.riskRequest.RiskAssessmentPEARList=this.UpdatedAssessmentPear;
      }
      if (this.RiskassessmentAssets) {
        const assessmentAssetsPear = new PearDetails();
        assessmentAssetsPear.RiskPear = this.RiskassessmentAssets.AssetsRiskPear;
        assessmentAssetsPear.RiskSeverity = this.RiskassessmentAssets.AssetsRiskSeverity;
        assessmentAssetsPear.RiskLikelihood = this.RiskassessmentAssets.AssetsRiskLikelihood;
        this.UpdatedAssessmentPear.push(assessmentAssetsPear);
        raiseRisk.RiskAssessmentPEARList = this.UpdatedAssessmentPear;
        this.riskRequest.RiskAssessmentPEARList=this.UpdatedAssessmentPear;
      }
      if (this.RiskassessmentReputation) {
        const assessmentsReputationPear = new PearDetails();
        assessmentsReputationPear.RiskPear = this.RiskassessmentReputation.ReputationRiskPear;
        assessmentsReputationPear.RiskSeverity = this.RiskassessmentReputation.ReputationRiskSeverity;
        assessmentsReputationPear.RiskLikelihood = this.RiskassessmentReputation.ReputationRiskLikelihood;
        this.UpdatedAssessmentPear.push(assessmentsReputationPear);
        raiseRisk.RiskAssessmentPEARList = this.UpdatedAssessmentPear;
        this.riskRequest.RiskAssessmentPEARList=this.UpdatedAssessmentPear;
      }
      if (this.RiskassessmentNPT) {
        const assessmentsNPTPear = new PearDetails();
        assessmentsNPTPear.RiskPear = this.RiskassessmentNPT.NPTRiskPear;
        assessmentsNPTPear.RiskSeverity = this.RiskassessmentNPT.NPTRiskSeverity;
        assessmentsNPTPear.RiskLikelihood = this.RiskassessmentNPT.NPTRiskLikelihood;
        this.UpdatedAssessmentPear.push(assessmentsNPTPear);
        raiseRisk.RiskAssessmentPEARList = this.UpdatedAssessmentPear;
        this.riskRequest.RiskAssessmentPEARList=this.UpdatedAssessmentPear;
      }
      raiseRisk.RiskRequest.UnitId = parseInt(this.selectedUnit.UnitId);
      raiseRisk.RiskRequest.RiskManagementToolId = ConstantsService.RiskManagementTool.HEMP;
      // if(this.raiseRisk.RiskRequest.RiskMovementId == 1){this.riskMovementText = "Increasing"}
      // else if(this.raiseRisk.RiskRequest.RiskMovementId == 2){this.riskMovementText = "Decreasing"}
      // else if(this.raiseRisk.RiskRequest.RiskMovementId == 3){this.riskMovementText = "Stable"}
      raiseRisk.RiskRequest.RiskMovement = "";
      raiseRisk.RiskRequest.RiskIdentifiedBy = this.selectedUserEmp.UserId;
      raiseRisk.RiskRequest.RiskRequestHEMP.RiskOwnerPartyId = this.selectedUserForRiskOwner.UserId;
      raiseRisk.RiskRequest.RiskRequestHEMP.SelectedriskControlTechniqueIds = this.selectedriskControlTechniqueId;
      raiseRisk.RiskRequest.RiskRequestHEMP.RiskRequestPreventiveActions=this.PreventiveActionsList;
      raiseRisk.RiskRequest.RiskRequestHEMP.RiskRequestMitigativePlan=this.MitigativePlansList;
     // this.trackDetails(raiseRisk);
      const apiRequest = {
        Model: raiseRisk
      };
      this.riskService.updateRiskForSelectedTool(
        apiRequest,
        this.updateRiskSuccess.bind(this)
      );
    } else {
      this.baseService.showRootLoader = false;
      this.alertType = ConstantsService.Error;
      this.errorDetails = "Please fill all Mandatory fields.";
    }
  }

  updateRiskSuccess(response: { Result: any; }) {
    if (response && response.Result) {
      // show success message
      this.alertFrom = "RaiseUpdate";
      // this.alertType = ConstantsService.Success;
      // this.successDetails = 'Risk details has been updated successfully';
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Risk details has been updated successfully"
      );
      this.router.navigate([RiskConstantsService.RedirectUrls.MyRiskRequest]);
      if (this.actionList.length > 0) {
        this.updateAction();
      }

      this.riskRequest.UnitName=this.selectedUnit.UnitName;
      this.riskRequest.RiskIdentifyBy = this.selectedUserEmp.FullName;
      this.selctedRiskId=[];
    this.selectedriskControlTechniqueId.forEach(element => {
       this.selctedRiskId.push(this.riskControlTechniqueDet.find(x=>x.Id ===element).Type);
    });
    this.riskRequest.SelectedRiskControlNames=this.selctedRiskId;
      this.updateActionTrack = JSON.parse(
        this.riskService.getUpdatedData("UpdateAction")
      );
        this.trackdetails(
          this.updateActionTrack,
          this.riskRequest,
          "UpdateAction",
          false
        );
      if (this.lifeSavingCheckedValueData.length > 0) {
        this.submitSpecificationData();
      }
      this.savePDF(this.riskRequest.RiskRequestId);
    }
    this.baseService.showRootLoader = false;
    
  }
 
  oldActionData;
  trackdetails(OldValue, NewValue, action, isNew) {
    const columnNames = Object.getOwnPropertyNames(this.riskRequest);
    columnNames.forEach(element => {
      if (OldValue.length === 0) {
        this.retVal = false;
        // OldValue = null;
      } else {
        this.retVal = this.commonService.isDataEqual(
          OldValue[element],
          NewValue[element]
        );
      }
      if (this.retVal === false) {
        switch (action) {
          case "UpdateAction":
      
      if (element === "UnitName") {
        this.retVal = this.commonService.isDataEqual(
          OldValue[element],
          NewValue[element]
        );
        if (this.retVal === false) {
          const userLoginActivity = new UserLogInActivity();
          userLoginActivity.FieldName = element;
          userLoginActivity.OldValue = isNew ? null : OldValue[element];
          userLoginActivity.NewValue = NewValue[element];
          if(OldValue.UnitId != NewValue.UnitId){
            this.userActivityList.push(userLoginActivity);}
        }
      }  else if (element === "LocationId") {
        this.retVal = this.commonService.isDataEqual(
          OldValue[element],
          NewValue[element]
        );
        if (this.retVal === false) {
          const userLoginActivity = new UserLogInActivity();
          userLoginActivity.FieldName = "LocationIdRisk";
          userLoginActivity.OldValue = isNew ? null : OldValue[element];
          userLoginActivity.NewValue = NewValue[element];
          this.userActivityList.push(userLoginActivity);
        }
      }  
      else if (element === "ExactLocation") {
     
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
        userLoginActivity.OldValue = isNew ? null : OldValue[element];
        userLoginActivity.NewValue = NewValue[element];
        this.userActivityList.push(userLoginActivity);
      
    }
      // else if (element === "ProjectId") {
      //   this.retVal = this.commonService.isDataEqual(
      //     OldValue[element],
      //     NewValue[element]
      //   );
      //   if (this.retVal === false) {
      //     const userLoginActivity = new UserLogInActivity();
      //     userLoginActivity.FieldName = "Project Name";
      //     userLoginActivity.OldValue = isNew ? null : OldValue[element];
      //     userLoginActivity.NewValue = NewValue[element];
      //     this.userActivityList.push(userLoginActivity);
      //   }
      //  }
      else if (element === "RiskSourceId") {
        this.retVal = this.commonService.isDataEqual(
          OldValue[element],
          NewValue[element]
        );
        if (this.retVal === false) {
          const userLoginActivity = new UserLogInActivity();
          userLoginActivity.FieldName = "Risk Source";
          userLoginActivity.OldValue = isNew ? null : OldValue[element];
          userLoginActivity.NewValue = NewValue[element];
          this.userActivityList.push(userLoginActivity);
        }
      }
      // else if (element === "ActivityLeadingToHazard"
      // || element === "Consequences"
      // || element === "HazardIdentified"
      // || element === "RiskTitle"
      // || element === "ThreatIdentified"
      //   || element ==="RiskIdentifyBy"
      // ) 
      else if (element === "ActivityLeadingToHazard"
        || element === "HazardIdentified"
        || element === "RiskTitle"
        || element ==="RiskIdentifyBy"
        || element === "ThreatIdentified"
      ) 
      {
        this.retVal = this.commonService.isDataEqual(
          OldValue[element],
          NewValue[element]
        );
        if (this.retVal === false) {
          const userLoginActivity = new UserLogInActivity();
          userLoginActivity.FieldName = element;
          userLoginActivity.OldValue = isNew ? null : OldValue[element];
          userLoginActivity.NewValue = NewValue[element];
          this.userActivityList.push(userLoginActivity);
        }
      }else if (element === "RiskRequestHEMP") {
        
        // const userLoginActivity = new UserLogInActivity();
        //   userLoginActivity.FieldName = "Activity";
        //   userLoginActivity.OldValue = isNew ? null : OldValue[element].Activity;
        //   userLoginActivity.NewValue = NewValue[element].Activity;
         
        //   if(userLoginActivity.OldValue!=userLoginActivity.NewValue){
        //     this.userActivityList.push(userLoginActivity);
        //   }
         

        //   const userLoginActivity2 = new UserLogInActivity();
        //   userLoginActivity2.FieldName = "HazardAssociatedWithActivity";
        //   userLoginActivity2.OldValue = isNew ? null : OldValue[element].HazardAssociatedWithActivity;
        //   userLoginActivity2.NewValue = NewValue[element].HazardAssociatedWithActivity;
         
        //   if(userLoginActivity2.OldValue!=userLoginActivity2.NewValue){
        //     this.userActivityList.push(userLoginActivity2);
        //   }
          const userLoginActivity3 = new UserLogInActivity();
          userLoginActivity3.FieldName = "ReferenceToStandards";
          userLoginActivity3.OldValue = isNew ? null : OldValue[element].ReferenceToStandards;
          userLoginActivity3.NewValue = NewValue[element].ReferenceToStandards;
         
          if(userLoginActivity3.OldValue!=userLoginActivity3.NewValue){
            this.userActivityList.push(userLoginActivity3);
          }
          const userLoginActivity4 = new UserLogInActivity();
          userLoginActivity4.FieldName = "RiskConsequences";
          userLoginActivity4.OldValue = isNew ? null : OldValue[element].RiskConsequences;
          userLoginActivity4.NewValue = NewValue[element].RiskConsequences;
         
          if(userLoginActivity4.OldValue!=userLoginActivity4.NewValue){
            this.userActivityList.push(userLoginActivity4);
          }
          const userLoginActivity5 = new UserLogInActivity();
          userLoginActivity5.FieldName = "RiskEvents";
          userLoginActivity5.OldValue = isNew ? null : OldValue[element].RiskEvents;
          userLoginActivity5.NewValue = NewValue[element].RiskEvents;
         
          if(userLoginActivity5.OldValue!=userLoginActivity5.NewValue){
            this.userActivityList.push(userLoginActivity5);
          }
          const userLoginActivity6 = new UserLogInActivity();
          userLoginActivity6.FieldName = "RiskThreats";
          userLoginActivity6.OldValue = isNew ? null : OldValue[element].RiskThreats;
          userLoginActivity6.NewValue = NewValue[element].RiskThreats;
         
          if(userLoginActivity6.OldValue!=userLoginActivity6.NewValue){
            this.userActivityList.push(userLoginActivity6);
          }
          const userLoginActivity7 = new UserLogInActivity();
          userLoginActivity7.FieldName = "RiskOwnerParty";
          userLoginActivity7.OldValue = isNew ? null : OldValue[element].RiskOwnerParty.FullName;
          userLoginActivity7.NewValue = NewValue[element].RiskOwnerParty.FullName;
         
          if(userLoginActivity7.OldValue!=userLoginActivity7.NewValue){
            this.userActivityList.push(userLoginActivity7);
          }
          for(var i=0;i<this.MitigativePlansList.length;i++)
          {
             //Mitigative Plan Comparison
             const userLoginActivity = new UserLogInActivity();
             userLoginActivity.FieldName = "Mitigative Plan - "  + i;
             userLoginActivity.OldValue =  OldValue[element].RiskRequestMitigativePlan[i] != undefined? OldValue[element].RiskRequestMitigativePlan[i].MitigativePlan:"";
            // userLoginActivity.NewValue = this.MitigativePlansList[i] != undefined ? this.MitigativePlansList[i].MitigativePlan : "";
             userLoginActivity.NewValue = this.MitigativePlansList[i] != undefined ? (this.MitigativePlansList[i].RiskRequestMitigativePlan!=undefined?this.MitigativePlansList[i].RiskRequestMitigativePlan.MitigativePlan:this.MitigativePlansList[i].MitigativePlan) : "";
             if(userLoginActivity.OldValue != userLoginActivity.NewValue)
             {
               this.userActivityList.push(userLoginActivity);
             }
            }
          
            //Preventive Action Comparison
            for(var i=0;i<this.PreventiveActionsList.length;i++)
            {
          const userLoginActivity9 = new UserLogInActivity();
          userLoginActivity9.FieldName = "Preventive Action - "  + i;
          userLoginActivity9.OldValue = OldValue[element].RiskRequestPreventiveActions[i] != undefined?  OldValue[element].RiskRequestPreventiveActions[i].PreventiveAction : "";
          userLoginActivity9.NewValue = this.PreventiveActionsList[i] != undefined ? (this.PreventiveActionsList[i].RiskRequestPreventiveActions!=undefined?this.PreventiveActionsList[i].RiskRequestPreventiveActions.PreventiveAction:this.PreventiveActionsList[i].PreventiveAction) : "";
          if(userLoginActivity9.OldValue!=userLoginActivity9.NewValue){
            this.userActivityList.push(userLoginActivity9);
          }
        }
          
       }  else if (element === "SelectedRiskControlNames") {
        this.retVal = this.commonService.isDataEqual(
          OldValue[element],
          NewValue[element]
        );
        if (this.retVal === false) {
          const userLoginActivity = new UserLogInActivity();
          userLoginActivity.FieldName = "Selected Risk Control Names";
          userLoginActivity.OldValue = isNew ? null : OldValue[element];
          userLoginActivity.NewValue = NewValue[element];
          this.userActivityList.push(userLoginActivity);
        }
      }
        else if (element === "PotentialPEARList") {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = "Potential Risk";
        this.severityMaster.forEach((observe) => {
          this.riskRequest.PotentialPEARList.forEach((observeid) => {
          if(observeid.RiskPear=="People" ||observeid.RiskPear=="Environment" || observeid.RiskPear=="Assets" || observeid.RiskPear=="Reputation" || observeid.RiskPear=="NPT"){
            if (observe.Value == observeid.RiskSeverity) {
             userLoginActivity.NewValue += observeid.RiskPear+" : "+observe.Name + ", "+observeid.RiskLikelihood+", ";
          }}
          });
          
          if (this.updateActionTrack) {
          this.updateActionTrack["PotentialPEARList"].forEach((observeid) => {
            if(observeid.RiskPear=="People" ||observeid.RiskPear=="Environment" || observeid.RiskPear=="Assets" || observeid.RiskPear=="Reputation" || observeid.RiskPear=="NPT"){
              if (observe.Value == observeid.RiskSeverity) {
               userLoginActivity.OldValue += observeid.RiskPear+" : "+observe.Name + ", "+observeid.RiskLikelihood+", ";
            }}
            });
          } else {
          userLoginActivity.OldValue = null;
          }
         });
        if( userLoginActivity.OldValue!= userLoginActivity.NewValue){
          this.userActivityList.push(userLoginActivity);
        }
     } else if (element === "ResidualPEARList") {
      const userLoginActivity = new UserLogInActivity();
      userLoginActivity.FieldName = "Residual Risk";
      this.severityMaster.forEach((observe) => {
        this.riskRequest.ResidualPEARList.forEach((observeid) => {
        if(observeid.RiskPear=="People" ||observeid.RiskPear=="Environment" || observeid.RiskPear=="Assets" || observeid.RiskPear=="Reputation" || observeid.RiskPear=="NPT"){
          if (observe.Value == observeid.RiskSeverity) {
           userLoginActivity.NewValue += observeid.RiskPear+" : "+observe.Name + ", "+observeid.RiskLikelihood+", ";
        }}
        });
        
        if (this.updateActionTrack) {
        this.updateActionTrack["ResidualPEARList"].forEach((observeid) => {
          if(observeid.RiskPear=="People" ||observeid.RiskPear=="Environment" || observeid.RiskPear=="Assets" || observeid.RiskPear=="Reputation" || observeid.RiskPear=="NPT"){
            if (observe.Value == observeid.RiskSeverity) {
             userLoginActivity.OldValue += observeid.RiskPear+" : "+observe.Name + ", "+observeid.RiskLikelihood+", ";
          }}
          });
        } else {
        userLoginActivity.OldValue = null;
        }
       });
      if( userLoginActivity.OldValue!= userLoginActivity.NewValue){
        this.userActivityList.push(userLoginActivity);
      }
   }      
  }
 }
    });
    this.oldActionData = JSON.parse(
      this.riskService.getoldActionData()
    );
    for(var i=0;i<this.actionList.length;i++)
    {
                 
       //Action Description Comparison
       const userLoginActivity = new UserLogInActivity();
       userLoginActivity.FieldName = "Action Description - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
       userLoginActivity.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].Action : ""; 
       userLoginActivity.NewValue = this.actionList[i] != undefined ? this.actionList[i].Action : "";
       if(userLoginActivity.OldValue != userLoginActivity.NewValue)
       {
         this.userActivityList.push(userLoginActivity);
       }
               
       //Action Owner Comparison
       const userLoginActivity1 = new UserLogInActivity();
       userLoginActivity1.FieldName = "Action Owner - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId );
       userLoginActivity1.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].ActionOwner.FullName : ""; 
       userLoginActivity1.NewValue = this.actionList[i] != undefined ? this.actionList[i].ActionOwner.FullName : "";
       if(userLoginActivity1.OldValue != userLoginActivity1.NewValue)
       {
         this.userActivityList.push(userLoginActivity1);
       }

        //Action Party Comparison
        const userLoginActivity2 = new UserLogInActivity();
        userLoginActivity2.FieldName = "Action Party - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
        userLoginActivity2.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].selectedActionParty.FullName : ""; 
        userLoginActivity2.NewValue = this.actionList[i] != undefined ? this.actionList[i].selectedActionParty.FullName : "";
        if(userLoginActivity2.OldValue != userLoginActivity2.NewValue)
        {
          this.userActivityList.push(userLoginActivity2);
        }

         //Action Verifier Comparison
        //  const userLoginActivity3 = new UserLogInActivity();
        //  userLoginActivity3.FieldName = "Action Verifier - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
        //  userLoginActivity3.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].selectedActionVerifier.FullName : ""; 
        //  userLoginActivity3.NewValue = this.actionList[i] != undefined ? this.actionList[i].selectedActionVerifier.FullName : "";
        //  if(userLoginActivity3.OldValue != userLoginActivity3.NewValue)
        //  {
        //    this.userActivityList.push(userLoginActivity3);
        //  }

          //Action Priority Comparison
          const userLoginActivity4 = new UserLogInActivity();
          userLoginActivity4.FieldName = "Action Priority - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
          userLoginActivity4.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].Priority : ""; 
          if(userLoginActivity4.OldValue.toString() === "1")
          {
            userLoginActivity4.OldValue = "Low";
          }
          else if(userLoginActivity4.OldValue.toString() === "2")
          {
            userLoginActivity4.OldValue = "Medium";
          }
          else if(userLoginActivity4.OldValue.toString() === "3")
          {
            userLoginActivity4.OldValue = "High";
          }
          userLoginActivity4.NewValue = this.actionList[i] != undefined ?(this.actionList[i].Action !== "" ? this.actionList[i].Priority : "") : "";
          if(userLoginActivity4.NewValue.toString() === "1")
          {
            userLoginActivity4.NewValue = "Low";
          }
          else if(userLoginActivity4.NewValue.toString() === "2")
          {
            userLoginActivity4.NewValue = "Medium";
          }
          else if(userLoginActivity4.NewValue.toString() === "3")
          {
            userLoginActivity4.NewValue = "High";
          }
          if(userLoginActivity4.OldValue != userLoginActivity4.NewValue)
          {
            this.userActivityList.push(userLoginActivity4);
          }
          
        //Action Target Date Comparison
         const userLoginActivity5 = new UserLogInActivity();
         userLoginActivity5.FieldName = "Action Target Date - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
         userLoginActivity5.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].TargetDate : ""; 
         if(userLoginActivity5.OldValue !== "")
         {
          userLoginActivity5.OldValue = moment(
            moment.utc(userLoginActivity5.OldValue).local()
          ).toDate();
         }
         userLoginActivity5.NewValue = this.actionList[i] != undefined ?(this.actionList[i].Action !== "" ? this.actionList[i].TargetDate : "") : "";
         if(userLoginActivity5.NewValue !== "")
         {
          userLoginActivity5.NewValue = moment(
            moment.utc(userLoginActivity5.NewValue).local()
          ).toDate();
         }
         if(userLoginActivity5.OldValue != userLoginActivity5.NewValue)
         {
           this.userActivityList.push(userLoginActivity5);
         }

          //Action Files Comparison
          const userLoginActivity6 = new UserLogInActivity();
          userLoginActivity6.FieldName = "Action Files - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
          if (this.oldActionData[i] != undefined && this.oldActionData[i].Files.length > 0) {
            for (var j = 0; j < this.oldActionData[i].Files.length; j++) {
              const url = this.oldActionData[i].Files[j]
                .Name;
              userLoginActivity6.OldValue += url + ",";
            }
          } else {
            userLoginActivity6.OldValue = "";
          }
          if (this.actionList[i] != undefined && this.actionList[i].Files.length > 0) {
            for (var j = 0; j < this.actionList[i].Files.length; j++) {
              const url = this.actionList[i].Files[j]
                .Name;
              userLoginActivity6.NewValue += url + ",";
            }
          } else {
            userLoginActivity6.NewValue = "";
          }
          if(userLoginActivity6.OldValue != userLoginActivity6.NewValue)
          {
            this.userActivityList.push(userLoginActivity6);
          }
    }
    if (this.userActivityList.length > 0) {
      this.commonService.saveUserActivityDetails(
        this.riskRequest.RiskRequestId,
            new Date(),
            "Risk-HEMP",
            this.loggedInUserJSON.UserId,
            this.userActivityList
      );
    }
  }

  /**
   * Check the checkbox
   * @param RiskType : risk type i.e. Potential
   * @param Category : category type i.e. PEAR
   */
  selectPotentialSection(Checked: any, RiskType: any, Category: string) {
    switch (RiskType) {
      case RiskConstantsService.RiskType.Potential:
        if (Category === "People") {
          if (Checked) {
            this.PotentialPeopleRisk.PeopleSelected = true;
          } else {
            this.PotentialPeopleRisk.PeopleSelected = false;
            this.PotentialPeopleRisk = new PeopleRisk();
          }
        }
        if (Category === "Assets") {
          if (Checked) {
            this.PotentialAssetsRisk.AssetsSelected = true;
          } else {
            this.PotentialAssetsRisk.AssetsSelected = false;
            this.PotentialAssetsRisk = new AssetsRisk();
          }
        }
        if (Category === "Environment") {
          if (Checked) {
            this.PotentialEnvironmentRisk.EnvironmentSelected = true;
          } else {
            this.PotentialEnvironmentRisk.EnvironmentSelected = false;
            this.PotentialEnvironmentRisk = new EnvironmentRisk();
          }
        }
        if (Category === "Reputation") {
          if (Checked) {
            this.PotentialReputationRisk.ReputationSelected = true;
          } else {
            this.PotentialReputationRisk.ReputationSelected = false;
            this.PotentialReputationRisk = new ReputationRisk();
          }
        }
        if (Category === "NPT") {
          if (Checked) {
            this.PotentialNPTRisk.NPTSelected = true;
          } else {
            this.PotentialNPTRisk.NPTSelected = false;
            this.PotentialNPTRisk = new NPTRisk();
          }
        }
        break;
      case RiskConstantsService.RiskType.Residual:
        break;
    }
  }

  /**
   * Check the checkbox
   * @param RiskType : risk type i.e. Potential
   * @param Category : category type i.e. PEAR
   */
  selectResidualSection(Checked: any, RiskType: any, Category: string) {
    switch (RiskType) {
      case RiskConstantsService.RiskType.Residual:
        if (Category === "People") {
          if (Checked) {
            this.ResidualPeopleRisk.PeopleSelected = true;
          } else {
            this.ResidualPeopleRisk.PeopleSelected = false;
            this.ResidualPeopleRisk = new PeopleRisk();
          }
        }
        if (Category === "Assets") {
          if (Checked) {
            this.ResidualAssetsRisk.AssetsSelected = true;
          } else {
            this.ResidualAssetsRisk.AssetsSelected = false;
            this.ResidualAssetsRisk = new AssetsRisk();
          }
        }
        if (Category === "Environment") {
          if (Checked) {
            this.ResidualEnvironmentRisk.EnvironmentSelected = true;
          } else {
            this.ResidualEnvironmentRisk.EnvironmentSelected = false;
            this.ResidualEnvironmentRisk = new EnvironmentRisk();
          }
        }
        if (Category === "Reputation") {
          if (Checked) {
            this.ResidualReputationRisk.ReputationSelected = true;
          } else {
            this.ResidualReputationRisk.ReputationSelected = false;
            this.ResidualReputationRisk = new ReputationRisk();
          }
        }
        if (Category === "NPT") {
          if (Checked) {
            this.ResidualNPTRisk.NPTSelected = true;
          } else {
            this.ResidualNPTRisk.NPTSelected = false;
            this.ResidualNPTRisk = new NPTRisk();
          }
        }
        break;
      case RiskConstantsService.RiskType.Potential:
        break;
    }
  }

  /**
   * Check the checkbox
   * @param RiskType : risk type i.e. Potential
   * @param Category : category type i.e. PEAR
   */
  selectAssessmentSection(Checked: any, RiskType: any, Category: string) {
    switch (RiskType) {
      case RiskConstantsService.RiskType.Assessment:
        if (Category === "People") {
          if (Checked) {
            this.RiskassessmentPeople.PeopleSelected = true;
          } else {
            this.RiskassessmentPeople.PeopleSelected = false;
            this.RiskassessmentPeople = new PeopleRisk();
          }
        }
        if (Category === "Assets") {
          if (Checked) {
            this.RiskassessmentAssets.AssetsSelected = true;
          } else {
            this.RiskassessmentAssets.AssetsSelected = false;
            this.RiskassessmentAssets = new AssetsRisk();
          }
        }
        if (Category === "Environment") {
          if (Checked) {
            this.RiskassessmentEnvironment.EnvironmentSelected = true;
          } else {
            this.RiskassessmentEnvironment.EnvironmentSelected = false;
            this.RiskassessmentEnvironment = new EnvironmentRisk();
          }
        }
        if (Category === "Reputation") {
          if (Checked) {
            this.RiskassessmentReputation.ReputationSelected = true;
          } else {
            this.RiskassessmentReputation.ReputationSelected = false;
            this.RiskassessmentReputation = new ReputationRisk();
          }
        }
        if (Category === "NPT") {
          if (Checked) {
            this.RiskassessmentNPT.NPTSelected = true;
          } else {
            this.RiskassessmentNPT.NPTSelected = false;
            this.RiskassessmentNPT = new NPTRisk();
          }
        }
        break;
      case RiskConstantsService.RiskType.Potential:
        break;
    }
  }
  createPEARList() {
    this.raiseRisk = new RaiseRisk();
    this.raiseRisk.PotentialPEARList = [];
    this.raiseRisk.ResidualPEARList = [];
    this.raiseRisk.RiskAssessmentPEARList = [];
    this.actionList.forEach((element: { UnitId: number; }) => {
      element.UnitId = parseInt(this.selectedUnit.UnitId);
    });
    this.raiseRisk.ActionDetails = this.actionList;
    this.riskRequest.RaisedBy = this.loggedInUserJSON.UserId;
    this.raiseRisk.RiskRequest = this.riskRequest;
    if (this.PotentialPeopleRisk) {
      const tempPear = new PearDetails();
      tempPear.RiskPear = this.PotentialPeopleRisk.PeopleRiskPear;
      tempPear.RiskSeverity = this.PotentialPeopleRisk.PeopleRiskSeverity;
      tempPear.RiskLikelihood = this.PotentialPeopleRisk.PeopleRiskLikelihood;
      this.raiseRisk.PotentialPEARList.push(tempPear);
    }
    if (this.PotentialEnvironmentRisk) {
      const tempEnvironmentPear = new PearDetails();
      tempEnvironmentPear.RiskPear = this.PotentialEnvironmentRisk.EnvironmentRiskPear;
      tempEnvironmentPear.RiskSeverity = this.PotentialEnvironmentRisk.EnvironmentRiskSeverity;
      tempEnvironmentPear.RiskLikelihood = this.PotentialEnvironmentRisk.EnvironmentRiskLikelihood;

      this.raiseRisk.PotentialPEARList.push(tempEnvironmentPear);
    }
    if (this.PotentialAssetsRisk) {
      const tempAssetsPear = new PearDetails();
      tempAssetsPear.RiskPear = this.PotentialAssetsRisk.AssetsRiskPear;
      tempAssetsPear.RiskSeverity = this.PotentialAssetsRisk.AssetsRiskSeverity;
      tempAssetsPear.RiskLikelihood = this.PotentialAssetsRisk.AssetsRiskLikelihood;
      this.raiseRisk.PotentialPEARList.push(tempAssetsPear);
    }
    if (this.PotentialReputationRisk) {
      const tempReputationPear = new PearDetails();
      tempReputationPear.RiskPear = this.PotentialReputationRisk.ReputationRiskPear;
      tempReputationPear.RiskSeverity = this.PotentialReputationRisk.ReputationRiskSeverity;
      tempReputationPear.RiskLikelihood = this.PotentialReputationRisk.ReputationRiskLikelihood;
      this.raiseRisk.PotentialPEARList.push(tempReputationPear);
    }
    if (this.PotentialNPTRisk) {
      const tempNPTPear = new PearDetails();
      tempNPTPear.RiskPear = this.PotentialNPTRisk.NPTRiskPear;
      tempNPTPear.RiskSeverity = this.PotentialNPTRisk.NPTRiskSeverity;
      tempNPTPear.RiskLikelihood = this.PotentialNPTRisk.NPTRiskLikelihood;
      this.raiseRisk.PotentialPEARList.push(tempNPTPear);
    }

    if (this.ResidualPeopleRisk) {
      const residualPear = new PearDetails();
      residualPear.RiskPear = this.ResidualPeopleRisk.PeopleRiskPear;
      residualPear.RiskSeverity = this.ResidualPeopleRisk.PeopleRiskSeverity;
      residualPear.RiskLikelihood = this.ResidualPeopleRisk.PeopleRiskLikelihood;
      this.raiseRisk.ResidualPEARList.push(residualPear);
    }
    if (this.ResidualEnvironmentRisk) {
      const residualEnvPear = new PearDetails();
      residualEnvPear.RiskPear = this.ResidualEnvironmentRisk.EnvironmentRiskPear;
      residualEnvPear.RiskSeverity = this.ResidualEnvironmentRisk.EnvironmentRiskSeverity;
      residualEnvPear.RiskLikelihood = this.ResidualEnvironmentRisk.EnvironmentRiskLikelihood;
      this.raiseRisk.ResidualPEARList.push(residualEnvPear);
    }
    if (this.ResidualAssetsRisk) {
      const residualAssetsPear = new PearDetails();
      residualAssetsPear.RiskPear = this.ResidualAssetsRisk.AssetsRiskPear;
      residualAssetsPear.RiskSeverity = this.ResidualAssetsRisk.AssetsRiskSeverity;
      residualAssetsPear.RiskLikelihood = this.ResidualAssetsRisk.AssetsRiskLikelihood;
      this.raiseRisk.ResidualPEARList.push(residualAssetsPear);
    }
    if (this.ResidualReputationRisk) {
      const residualReputationPear = new PearDetails();
      residualReputationPear.RiskPear = this.ResidualReputationRisk.ReputationRiskPear;
      residualReputationPear.RiskSeverity = this.ResidualReputationRisk.ReputationRiskSeverity;
      residualReputationPear.RiskLikelihood = this.ResidualReputationRisk.ReputationRiskLikelihood;
      this.raiseRisk.ResidualPEARList.push(residualReputationPear);
    }
    if (this.ResidualNPTRisk) {
      const residualNPTPear = new PearDetails();
      residualNPTPear.RiskPear = this.ResidualNPTRisk.NPTRiskPear;
      residualNPTPear.RiskSeverity = this.ResidualNPTRisk.NPTRiskSeverity;
      residualNPTPear.RiskLikelihood = this.ResidualNPTRisk.NPTRiskLikelihood;
      this.raiseRisk.ResidualPEARList.push(residualNPTPear);
    }

    if (this.RiskassessmentPeople) {
      const assessmentPear = new PearDetails();
      assessmentPear.RiskPear = this.RiskassessmentPeople.PeopleRiskPear;
      assessmentPear.RiskSeverity = this.RiskassessmentPeople.PeopleRiskSeverity;
      assessmentPear.RiskLikelihood = this.RiskassessmentPeople.PeopleRiskLikelihood;
      this.raiseRisk.RiskAssessmentPEARList.push(assessmentPear);
    }
    if (this.RiskassessmentEnvironment) {
      const assessmentEnvPear = new PearDetails();
      assessmentEnvPear.RiskPear = this.RiskassessmentEnvironment.EnvironmentRiskPear;
      assessmentEnvPear.RiskSeverity = this.RiskassessmentEnvironment.EnvironmentRiskSeverity;
      assessmentEnvPear.RiskLikelihood = this.RiskassessmentEnvironment.EnvironmentRiskLikelihood;
      this.raiseRisk.RiskAssessmentPEARList.push(assessmentEnvPear);
    }
    if (this.RiskassessmentAssets) {
      const assessmentAssetsPear = new PearDetails();
      assessmentAssetsPear.RiskPear = this.RiskassessmentAssets.AssetsRiskPear;
      assessmentAssetsPear.RiskSeverity = this.RiskassessmentAssets.AssetsRiskSeverity;
      assessmentAssetsPear.RiskLikelihood = this.RiskassessmentAssets.AssetsRiskLikelihood;
      this.raiseRisk.RiskAssessmentPEARList.push(assessmentAssetsPear);
    }
    if (this.RiskassessmentReputation) {
      const assessmentsReputationPear = new PearDetails();
      assessmentsReputationPear.RiskPear = this.RiskassessmentReputation.ReputationRiskPear;
      assessmentsReputationPear.RiskSeverity = this.RiskassessmentReputation.ReputationRiskSeverity;
      assessmentsReputationPear.RiskLikelihood = this.RiskassessmentReputation.ReputationRiskLikelihood;
      this.raiseRisk.RiskAssessmentPEARList.push(assessmentsReputationPear);
    }
    if (this.RiskassessmentNPT) {
      const assessmentsNPTPear = new PearDetails();
      assessmentsNPTPear.RiskPear = this.RiskassessmentNPT.NPTRiskPear;
      assessmentsNPTPear.RiskSeverity = this.RiskassessmentNPT.NPTRiskSeverity;
      assessmentsNPTPear.RiskLikelihood = this.RiskassessmentNPT.NPTRiskLikelihood;
      this.raiseRisk.RiskAssessmentPEARList.push(assessmentsNPTPear);
    }
  }

  /**
   * send to line graph
   */
  sendtoLineGraph() {
    this.createPEARList();
    this.data = [];
    this.raiseRisk.PotentialPEARList.forEach(pearDetails => {
      if (
        this.max <
        pearDetails.RiskSeverity *
        this.riskService.ChangeAlphabetToNumber(pearDetails.RiskLikelihood)
      ) {
        this.max =
          pearDetails.RiskSeverity *
          this.riskService.ChangeAlphabetToNumber(pearDetails.RiskLikelihood);
        this.pear = pearDetails.RiskPear.toString();
      }
    });
    this.raiseRisk.PotentialPEARList.forEach(element => {
      if (element.RiskPear === this.pear) {
        const custData = new CustomObject();
        custData.module = +element.RiskSeverity;
        custData.value = this.riskService.ChangeAlphabetToNumber(
          element.RiskLikelihood
        );
        custData.pearName = this.pear;
        this.data.push(custData);
      }
    });
    this.raiseRisk.RiskAssessmentPEARList.forEach(element => {
      if (element.RiskPear === this.pear) {
        const custData = new CustomObject();
        custData.module = +element.RiskSeverity;
        custData.value = this.riskService.ChangeAlphabetToNumber(
          element.RiskLikelihood
        );
        custData.pearName = this.pear;
        this.data.push(custData);
      }
    });
    this.raiseRisk.ResidualPEARList.forEach(element => {
      if (element.RiskPear === this.pear) {
        const custData = new CustomObject();
        custData.module = +element.RiskSeverity;
        custData.value = this.riskService.ChangeAlphabetToNumber(
          element.RiskLikelihood
        );
        custData.pearName = this.pear;
        this.data.push(custData);
      }
    });
    this.baseService.setDataForLine(this.data);
  }
  downloadPDF() {
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download is in Progress!"
    );
    const apiRequest = {
      Model: {
        ProcessName: "Risk",
        SourceId: this.selectedRiskRequestId
      }
    };
    this.riskService.downloadPDF(
      apiRequest,
      this.callbackMethodForDownloadPDF.bind(this)
    );
  }

  callbackMethodForDownloadPDF(response: any) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName =
        "pdf_riskrequest" + this.selectedRiskRequestId + ".pdf"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);

    }
  }
  
  deleteRiskRequest() {
    if (!this.deletionReason) {
      this.isDeletionreason = true;
    } else {
      this.alertType = ConstantsService.Confirm;
      this.confirmMessage = "Sure you want to delete it?";
    }
  }
  callbackMethodForDeleteRisk(response: { Success: boolean; }) {
    if (response.Success === true) {
      // this.alertType = ConstantsService.Success;
      // this.successDetails = 'Risk has been Deleted';
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Risk has been Deleted."
      );
      this.router.navigate([RiskConstantsService.RedirectUrls.MyRiskRequest]);
    }
  }
  savePDF(riskId: number) {
    const apiRequest = {
      Model: {
        ProcessName: "Risk",
        SourceId: riskId
      }
    };
    this.riskService.savePDF(
      apiRequest,
      this.callbackMethodForSavePDF.bind(this)
    );
  }
  callbackMethodForSavePDF(response: any) { }
  updateAction() {
    if (this.validateForm()) {
      this.actionDetailsForHseAdvisor.SourceId = this.riskRequest.RiskRequestId;
      this.actionDetailsForHseAdvisor.ProcessName =
        ActiontrackerConstantsService.ActiontrackerModuleConst.Risk;
      this.actionList.forEach(element => {
        element.UnitId = parseInt(this.selectedUnit.UnitId);
      });
      this.actionDetailsForHseAdvisor.ActionDetails = this.actionList;
      this.actionDetailsForHseAdvisor.RaisedBy = this.loggedInUserJSON.UserId;
      const apiRequest = {
        Model: this.actionDetailsForHseAdvisor
      };
      this.riskService.UpdateActionsForRisk(
        apiRequest,
        this.callbackFromUpdateActionHseAdvisor.bind(this)
      );
    }
  }
  callbackFromUpdateActionHseAdvisor(response: any) {
    this.baseService.showRootLoader = false;
   }
  checkPopUpValidation(action: any, actionId: any) {
    this.validatePopUp = true;
    switch (action) {
      case "Cancel":
        if (this.cancellationReason === "" 
          || this.cancellationReason === undefined
          || this.cancellationReason === null
        ) {
          this.showCancellationmsg = true;
          this.validatePopUp = false;
        }
        if (this.validatePopUp === true) {
          this.cancelAction(actionId);
        }
        break;
      case "Delete":
        if (this.deletionReason === ""
          || this.deletionReason === undefined
          || this.deletionReason === null) {
          this.showDeletionmsg = true;
          this.validatePopUp = false;
        }
        if (this.validatePopUp === true) {
          this.deleteAction(actionId);
        }
        break;
    }
  }
  cancelAction(cancelActionId: any) {
    if (this.cancelActionId > 0) {
      this.cancelRecord = true;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          ActionId: this.cancelActionId,
          CancellationReason: this.cancellationReason,
          UpdatedBy: this.loggedInUserJSON.UserId,
          StatusId: this.cancelStatusId
        }
      };
      this.observationService.cancelactiondetails(
        apiRequest,
        this.callbackMethodForCancelActionDetails.bind(this)
      );
    }
  }
  callbackMethodForCancelActionDetails(response: any) {
    this.cancelRecord = false;
    this.cancellationReason = "";
    this.ngOnInit();
  }
  deleteAction(deleteActionId: any) {
    if (this.deleteActionId > 1) {
      this.deleteRecord = true;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          ActionId: this.deleteActionId,
          DeletionReason: this.deletionReason,
          UpdatedBy: this.loggedInUserJSON.UserId,
          StatusId: this.actionStatusId
        }
      };
      this.observationService.deleteactiondetails(
        apiRequest,
        this.callbackMethodForDeleteActionDetails.bind(this)
      );
    }
  }
  callbackMethodForDeleteActionDetails(response: any) {
    this.deleteRecord = false;
    this.deletionReason = "";
    this.riskLoaded = false;
    this.ngOnInit();
  }
  cancelAssigned(actionId: any, index: any) {
    this.cancelRecord = true;
    this.cancelActionId = actionId;
  }
  deleteAssigned(actionId: number, index: any) {
    this.deleteRecord = true;
    this.deleteActionId = actionId;
  }
  onCancelClick() {
    this.cancelRecord = false;
    this.cancellationReason = "";
  }
  onCancel() {
    this.deleteRecord = false;
    this.deletionReason = "";
  }
  onPreviousClick() {
    this.isNext = true;
    this.riskIndex = -1;
    this.disableRisk = false;
    this.riskIds = this.riskService.getAllRiskIds();
    this.riskIds.forEach((element, index) => {
      if (element.RiskRequestId == this.selectedRiskRequestId && index - 1 != null) {
        this.riskIndex = index - 1;
        if (this.riskIndex <= 0) {
          this.isPrevious = false;
        } else {
          this.isPrevious = true;
        }
        return;
      }
    });
    this.selectedRiskRequestId = this.riskIds[this.riskIndex].RiskRequestId;
    if (this.riskIndex > -1) {
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          RiskRequestId: this.selectedRiskRequestId,
         // Tool : "HEMP"
        }
      };
      this.riskService.getRiskRequestForToolId(
        apiRequest,
        this.callbackMethodForgetgetRiskRequestForToolId.bind(this)
      );
    }
  }

  onNextClick() {
    this.isPrevious = true;
    this.riskIndex = -1;
    this.disableRisk = false;
    this.riskIds = this.riskService.getAllRiskIds();
    this.riskIds.forEach((element, index) => {
      if (element.RiskRequestId == this.selectedRiskRequestId && index + 1 != null) {
        this.riskIndex = index + 1;
        if (this.riskIndex + 1 == this.riskIds.length) {
          this.isNext = false;
        } else {
          this.isNext = true;
        }
        return;
      }
    });
    this.selectedRiskRequestId = this.riskIds[this.riskIndex].RiskRequestId;
    if (this.riskIndex > -1) {
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          RiskRequestId: this.selectedRiskRequestId,
         // Tool : "MOC"
        }
      };
      this.riskService.getRiskRequestForToolId(
        apiRequest,
        this.callbackMethodForgetgetRiskRequestForToolId.bind(this)
      );
    }
  }
  callbackMethodForgetgetRiskRequestForToolId(response) {
   
    if (response && response.Success) {
      this.ToolDetails = response.Result;
     
    } else {
      this.baseService.showRootLoader = false;
      this.baseService.processApiResponseError(response);
    }

    const apiRequest = {
      Model: {
        RiskRequestId: this.selectedRiskRequestId,
        Tool : this.ToolDetails.ToolName
      }
    };
    this.riskService.getRiskRequestForEditByTool(
      apiRequest,
      this.successGetRiskRequestForEdit.bind(this)
    );
    this.router.navigate(["risk/" +this.ToolDetails.PageName +"/" + this.selectedRiskRequestId]);
  }
  getAllModules() {
    this.masterscreenService.getAllModules(
      null,
      this.callbackMethodForGetAllModules.bind(this)
    );
  }
  callbackMethodForGetAllModules(response: { Success: any; Result: any[]; }) {
    if (response.Success) {
      this.moduleList = response.Result;
      this.moduleList.forEach(element => {
        if (element.ModuleName === "Risk") {
          this.moduleId = element.ModuleId;
        }
      });
    }
  }
  submitSpecificationData() {
    this.specificationDetailsData.RuleId = this.lifeSavingCheckedValueData;
    this.specificationDetailsData.SourceId = this.riskRequest.RiskRequestId;
    this.specificationDetailsData.ModuleId = this.moduleId;

    const apiRequest = {
      Model: this.specificationDetailsData
    };
    this.observationService.submitSpecificationData(
      apiRequest,
      this.callbackMethodForSubmitSpecificationData.bind(this)
    );
  }

  callbackMethodForSubmitSpecificationData(response: { Success: any; }) {
    if (response.Success) {
    }
  }
  categoryCheckedEmittedValue(data: any[]) {
    this.lifeSavingCheckedValueData = data;
  }
  nodeSelected(event: { node: any; }) {
    this.selectedUnit = event.node;
    if (this.selectedUnit.children && this.selectedUnit.children.length > 0) {
      this.selectedUnit.expanded = true;
    }
    this.getLocation();
    this.getPermissionDetails(this.selectedUnit.UnitId);
    this.isEmployeeUnit=true;
    if(event.node.UnitTypeId == 2)
    {
      this.isEmployeeUnit=false;
      this.getContractDetails(this.selectedUnit.UnitId);
    }
    else{
      this.selectedContractId =0;
      this.raiseRisk.RiskRequest.ContractId = 0;
    }
  }
  getContractDetails(unitId: number): void {
    const apiRequestUnit = {
      Model: {
        "UnitId": unitId
      },
    };
    this.masterscreenService.getContractDetailsData(
      apiRequestUnit,
      this.callbackMethodForContractDetails.bind(this)
    );
  }
  callbackMethodForContractDetails(response) {
     
    this.contracts = [];
    this.unitContractDetails = response;
    let contractHolderId;
    response.forEach(contract => {
      this.contracts.push({ label: contract.ContractNumber, value: contract.UnitContractDetailsId });
      
    });
    if (this.raiseRisk.RiskRequest != null && this.raiseRisk.RiskRequest != undefined && this.raiseRisk.RiskRequest.RiskId !== 0 && this.raiseRisk.RiskRequest.RiskId && this.contracts.some(c => c.value == this.riskRequest.ContractId.toString())) {
      let currentContract = this.contracts.find(c => c.value.toString() === this.riskRequest.ContractId.toString());
    
      this.isContractErrorMsg=false;
      this.checkHolder(currentContract);
      this.isContractHolder=false;
      if(currentContract!=null)
      {
      contractHolderId = response.find(h => h.UnitContractDetailsId.toString() === this.riskRequest.ContractId.toString()).ContractHolderId
      this.isContractHolder = contractHolderId === this.loggedInUserJSON.UserId ? true : false;
      }
    }
    else 
    {
      this.isContractErrorMsg=true;
    }
  }
  checkHolder(event) {
    
    this.selectedContractId=0;
    let contract;
    contract = this.unitContractDetails.find(contract => contract.UnitContractDetailsId === event.value);
    if (contract.ContractHolderId && contract.ContractNumber != '') {
      this.isContractErrorMsg=false;
      this.isHasContractDetails = true;
      this.selectedContractId=event.value;
     
    } 
    else {
      this.isContractErrorMsg=true;
      this.isHasContractDetails = false;
    }
  }
  callbackMethodForGetTreeData(response: { Result: UnitTreeNode[] | null; }) {
    if (response.Result !== null) {
      this.unitTree = response.Result;
      if (this.sourceId === 0) {
        this.unitTree.forEach(element => {
          this.compareTreeNode(element, 0);
        });
      }
    }
    this.getAllMasterForRaiseRisk();
  }
  compareTreeNode(node: UnitTreeNode, selectedNode: number) {
    var isFound: boolean = false;
    this.unitList.forEach(element => {
      if (element.UnitId === node.UnitId) {
        isFound = true;
      }
    });
    if (!isFound || !node.IsActive) {
      node.selectable = false;
      node.expanded = false;
    }
    if (node.ParentId !== 0) {
      node.expanded = false;
    }
    if (node.UnitId === selectedNode) {
      this.selectedUnit = node;
      this.expandParents(this.selectedUnit);
    }
    if (node.children && node.children.length > 0) {
      node.selectable = false;
      node.children.forEach((element: any) => {
        var isFound: boolean = false;
        this.unitList.forEach(unit => {
          if (unit.UnitId === element.UnitId) {
            isFound = true;
          }
        });
        if (!isFound || !element.IsActive) {
          element.selectable = false;
          element.expanded = false;
        }
        if (element.ParentId !== 0) {
          element.expanded = false;
        }
        if (element.UnitId === selectedNode) {
          this.selectedUnit = element;
          this.expandParents(this.selectedUnit);
        }
        if (element.children && element.children.length > 0) {
          this.compareTreeNode(element, selectedNode);
        }
      });
    }
  }
  expandParents(node: { parent: any }) {
    if (node.parent) {
      node.parent.expanded = true;
      this.expandParents(node.parent);
    }
  }
  onInputFilesUpdated(files: any[], type: any, index: number) {
    switch (type) {
      case "RiskAction":
        for (let i = 0; i < this.actionList.length; i++) {
          if (i === index) {
            this.actionList[index].Files = files;
          }
        }
        break;
      default:
        break;
    }
  }
  showActions(actionId: any, processId: any) {
    this.router.navigate([
      "/actiontracker/all-action-details",
      actionId,
      { processId: processId }
    ]);
  }
  getRemarks(remarks: string | String, type: any, index: string | number) {
    switch (type) {
      case "ActivityLeadingToHazard":
        this.riskRequest.ActivityLeadingToHazard = remarks;
        break;
      case "HazardIdentified":
        this.riskRequest.HazardIdentified = remarks;
        break;
      case "ThreatIdentified":
        this.riskRequest.ThreatIdentified = remarks;
        break;
      case "Consequences":
        this.riskRequest.Consequences = remarks;
        break;
      case "ControlMeasure":
        this.riskRequest.ControlMeasure = remarks;
        break;
      case "ContengencyPlan":
        this.riskRequest.ContengencyPlan = remarks;
        break;
      case "Action":
        this.actionList[index].Action = remarks;
        break;
      case "PreventiveActionList":  
        this.PreventiveActionsList[index].PreventiveAction = remarks;
        break;
      case "MitigativePlanList":  
        this.MitigativePlansList[index].MitigativePlan = remarks;
        break;  
      case "CancellationReason":
        this.cancellationReason = remarks;
        break;
      case "DeletionReason":
        this.deletionReason = remarks;
        break;
      case "Activity":
        this.riskRequest.RiskRequestHEMP.Activity = remarks;
        break;
      case "HazardAssociatedWithActivity":
        this.riskRequest.RiskRequestHEMP.HazardAssociatedWithActivity = remarks;
        break;
      case "RiskThreats":
        this.riskRequest.RiskRequestHEMP.RiskThreats = remarks;
        break;
      case "RiskEvents":
        this.riskRequest.RiskRequestHEMP.RiskEvents = remarks;
        break;   
      case "RiskConsequences":
        this.riskRequest.RiskRequestHEMP.RiskConsequences = remarks;
        break;
      case "PreventiveAction":
        this.riskRequest.RiskRequestHEMP.PreventiveAction = remarks;
        break;  
      case "MitigativePlan":
        this.riskRequest.RiskRequestHEMP.MitigativePlan = remarks;
        break;         
      default:
        break;
    }
  }
  getOutput(event: any) {
    if (event) {
      //this.ngOnInit();
      this.router.navigate([RiskConstantsService.RedirectUrls.MyRiskRequest]);
    }
  }

  saveAsDraft() {
    if (this.validateForm()) {
      const raiseRisk = new RaiseRisk();
      this.baseService.showRootLoader = true;
      this.bindActionOwnerIdToList();
      this.createPEARList();
      this.raiseRisk.RiskRequest.UnitId = parseInt(this.selectedUnit.UnitId);
      this.raiseRisk.RiskRequest.IsDraft = true;
      this.raiseRisk.RiskRequest.RiskId = this.selectedRiskRequestId;
      this.raiseRisk.RiskRequest.ContractId = this.isEmployeeUnit?0: this.selectedContractId;
      this.raiseRisk.RiskRequest.RiskManagementToolId = ConstantsService.RiskManagementTool.HEMP;
      // if(this.raiseRisk.RiskRequest.RiskRequestMOC.RiskMovementId == 1){this.riskMovementText = "Increasing"}
      // else if(this.raiseRisk.RiskRequest.RiskRequestMOC.RiskMovementId == 2){this.riskMovementText = "Decreasing"}
      // else if(this.raiseRisk.RiskRequest.RiskRequestMOC.RiskMovementId == 3){this.riskMovementText = "Stable"}
      this.raiseRisk.RiskRequest.RiskMovement = "";
      this.raiseRisk.RiskRequest.RiskIdentifiedBy = this.selectedUserEmp.UserId;
      this.raiseRisk.RiskRequest.RiskRequestHEMP.RiskOwnerPartyId = this.selectedUserForRiskOwner.UserId;
      this.raiseRisk.RiskRequest.RiskRequestHEMP.SelectedriskControlTechniqueIds = this.selectedriskControlTechniqueId;
      this.raiseRisk.RiskRequest.RiskRequestHEMP.RiskRequestPreventiveActions=this.PreventiveActionsList;
      this.raiseRisk.RiskRequest.RiskRequestHEMP.RiskRequestMitigativePlan=this.MitigativePlansList;
      const apiRequest = {
        Model: this.raiseRisk
      };
      this.riskService.raiseRiskForSelectedTool(apiRequest, this.raiseRiskSuccess.bind(this));
    }
    else {
      this.baseService.showRootLoader = false;
    }
  }

  removePreventiveActionFromList(index: number) {
    if (this.PreventiveActionsList.length > 1) {
      this.PreventiveActionsList.splice(index, 1);
    }
  }
  addPreventiveAction() {
    this.PreventiveActions = new RiskRequestPreventiveActions();
    this.PreventiveActionsList.push(this.PreventiveActions);
  }

  removeMitigativePlanFromList(index: number) {
    if (this.MitigativePlansList.length > 1) {
      this.MitigativePlansList.splice(index, 1);
    }
  }
  addMitigativePlan() {
    this.MitigativePlans = new RiskRequestMitigativePlan();
    this.MitigativePlansList.push(this.MitigativePlans);
  }

  getRiskControlTechniques() {
    this.baseService.showRootLoader = true;
    this.riskService.getRiskControlTechniques(
      this.callbackMethodForGetRiskControlTechniques.bind(this)
    );
  }

   callbackMethodForGetRiskControlTechniques(response) {
    this.riskControlTechniqueDet=response.Result;
    this.riskControlTechnique = [];
    if (response && response.Success) {
      this.riskControlTechnique = response.Result;
    } else {
      this.baseService.showRootLoader = false;
      this.baseService.processApiResponseError(response);
    }
  }

  SubmitCheckedRiskControlTechnique(riskTechnique, event) {
    if (event.target.checked) {
      this.selectedriskControlTechniqueId.push(riskTechnique.Id);
    } else {
      const index = this.selectedriskControlTechniqueId.indexOf(
        riskTechnique.Id
      );
      if (index > -1) {
        this.selectedriskControlTechniqueId.splice(index, 1);
      }
    }
  }

   //BOC Pritesh
   ReportshowDialog() {
    
    this.ReportUserId = this.loggedInUserJSON.UserId;
    this.ReportModule = "Risk-HEMP";
    this.ReportRecordId = this.selectedRiskRequestId;
    this.ReportProcessId = 0;
    this.dialogHeight = (window.innerHeight - 50).toString() + "px";
    this.dialogWidth = window.innerWidth.toString() + "px";
    this.ReportclosePopup = true;
  }
  ReportclosePopUp() {
    this.ReportclosePopup = false;
  }
  //EOC Pritesh

  //Approver Log -- Start
  ApprovershowDialog() {
    this.RiskId = this.selectedRiskRequestId;
    this.dialogHeight = (window.innerHeight - 50).toString() + "px";
    this.dialogWidth = window.innerWidth.toString() + "px";
    this.ApproverPopup = true;
  }
  ApproverclosePopUp() {
    this.ApproverPopup = false;
  }
  //Approver Log --End

  setLocation(location) {
    this.riskRequest.ExactLocation = location;
  }
  saveLocation() {
    this.baseService.setItemInSession(
      "Location" + this.loggedInUserJSON.Company.CompanyName,
      this.selectedLocation
    );
    this.locations.forEach((location) => {
      if (location.value === this.selectedLocation) {
        this.riskRequest.LocationId = location.value;
        this.isInactiveLocation = (location?.InActive === true)? true:false;
      }
    });
  }

  // method to get the location
  getLocation() {
    if (this.login) {
      this.login.UnitId = this.selectedUnit ? this.selectedUnit.UnitId : 0;
      const apiRequest = {
        Model: {
          ...this.login,
          GetActiveLocations: this.riskRequest.RiskRequestId == 0 ? true : false,
        }
      };
      // Call dummy method to post data
      this.observationService.getLocationData(
        apiRequest,
        this.callbackMethodForGetLocationData.bind(this)
      );
    }
  }

  // call back method of get location
  callbackMethodForGetLocationData(response) {
    let locationDetails = [];
    this.locations = [];
    if (response === undefined) {
      locationDetails = JSON.parse(
        this.baseService.getItemFromSession("locations_" + this.login.UnitId)
      );
    } else {
      if (response.Success) {
        locationDetails = response.Result;
      }
      if (response.Errors !== null) {
        this.notificationsService.toastNotify(
          "error",
          "Error Message",
          "Location list is empty."
        );
        this.hseErrorHandler.handleError(response.Errors);
      }
    }
    locationDetails.forEach((location) => {
      this.locations.push({
        label: location.LocationName,
        value: location.LocationId,
        InActive :location?.InActive
      });
      if (location.LocationId === this.selectedLocation) {
        this.riskRequest.LocationId = location.LocationId;
         this.isInactiveLocation = (location?.InActive === true)? true:false;
      }
    });
  }

  ///Import Excel
  //xlsMain: AOA = [];
  //xlsDetail: AOA = [];
  xlsMain:any;
  xlsDetail:any;
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };

   
    onSelectFile(evt: any)
    {
      this.disableImport=false;
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) 
    {
      this.notificationsService.toastNotify(
        "error",
        "Warning Message",
        "Please Select Single Excel File Only."
      );
      this.disableImport=true;
      return;
    }
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => 
    {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      let wsname: string = wb.SheetNames[0];
      let ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.xlsMain = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }  ));

      /* grab first sheet */
       wsname  = wb.SheetNames[1];
       ws= wb.Sheets[wsname];
      this.xlsDetail = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));

    //   // console.log(this.xlsMain);
    //   // console.log(this.xlsDetail);
 
    };
    reader.readAsBinaryString(target.files[0])

  }
  isImport:boolean=false;
  ImportExcel()
  {
     
     const apiRequest = {
      Model:
      {
        MainSheet: (this.xlsMain),
        DetailsSheet:this.xlsDetail,
        RiskManagementToolId:ConstantsService.RiskManagementTool.HEMP,
        RiskRequestId:this.selectedRiskRequestId

      } 
    };
    this.isImport=true;
    this.riskService.ImportRiskFromExcel(apiRequest, this.successGetRiskRequestForEdit.bind(this));
  }

  ImportErrorclosePopUp() {
    this.isShowErrorDialog = false;
  }
    fileUploadDialog:boolean = false;
    disableImport:boolean = true;
    ImportFileClick()
    {
      this.fileUploadDialog = true;
    }
  closePopUp()
  {
    this.fileUploadDialog = false;
  }
////Close Import Excel


//Export To Excel
ExportToExcel()
{     
  this.baseService.showRootLoader = true;
   const apiRequest = {
    Model:
    {
      RiskManagementToolId:ConstantsService.RiskManagementTool.HEMP,
      RiskRequestId:this.selectedRiskRequestId,
      FileName : "HEMP" 
    } 
  };
  this.riskService.ExportRiskToExcel(apiRequest, this.callbackMethodForExportRiskToExcel.bind(this));
}

callbackMethodForExportRiskToExcel(response) {
  if(response)
  { 
    this.baseService.showRootLoader = false;
      var fileDownLoadName = "HEMP-RSK" + this.selectedRiskRequestId + ".xlsx"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
  }
  else{
    this.notificationsService.toastNotify(
      "error",
      "Error Message",
      "Something Went Wrong."
    );
  }
}

 
 

}

export class CustomObject {
  value: number | undefined;
  module: number | undefined;
  pearName: string | undefined;
}
 